import React, { useContext, useEffect, useState } from "react";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import PatientDetails from "../../Components/PatientInformation";
import SideBarMenu from "../../Components/SideBarMenu";
import { AppContext } from "../../Contexts/AppContextProvider";
import DateControl from "../../Components/DateControl";
import { AllowNumberWithTwoDecimal, DateDisplayFormat, GetLocalStorageData, GetLoggedInUserID, GetOrdinal, IsAdmin, IsDateAfter, IsDateBefore, toggleSidebar } from "../../Helpers/Utilities";
import InfoPopUp from "../../Components/InfoPopUp";
import { HTTPResponse, SideMenuItems, ToastMessages, ToastMessageType, Values } from "../../Helpers/Enums";
import { CommonError_Msgs } from "../../Helpers/HelperText";
import { NutritionService } from "../../WebApiServices/Nutrition.service";
import DietAdministrationTable from "../../Components/DietAdministrationTable";
import ErrorField from "../../Components/ErrorField";

const NutritionManagement = () => {
 
    const patientId = GetLocalStorageData("patientId") || 0;
  const [hideColumns, setHideColumns] = useState([false, false, false, false, false, false]);
  const [hideMainColumns, setHideMainColumns] = useState([false, false, false, false, false, false]);
const [patientLocked, setpatientLocked] = useState(false);
 

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const locked = patientData?.locked ?? false;
  const submit = patientData?.submit ?? 0; 

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const [sickdayDietDetails, setSickdayDietDetails] = useState([
    {
      sickid: 0,

      startVisit: "",
      start_dt: "",
      start_dt_estimated: false,
      startHospitalizationsUnkLTLKT: "",

      ongoingVisit: "",
      end_dt: "",
      end_dt_estimated: false,
      endHospitalizationsUnkLTLKT: "",

            rfdMitigation: false,
            rfdDuring: false,
            rfdAfter: false,
            rfdRenal: false,
            rfdOtherMedical: false,
            rfdOtherMedical_txt: null,
            rfdOtherReason: false,
            rfdOtherReason_txt: null,
            rfdUnknown: false,



      cosDietary: false,
      cosDietaryCalory: false,
      cosDietaryProtien: false,
      cosDietaryProtienZero: false,
      cosDietaryCarb: false,
      cosDietaryLipid: false,
      cosDietaryUnknown: false,

      modidfied:false,
      modifiedNo:false,
      modifiedParental:false,
      modifiedEnteral:false,
      modifiedUnknown:false,

      cosIncreased:false,
      cosMiscro:false,
      cosOther:false,
      cosOther_Txt:"",
      cosUnknown:false,

      startDateInvalid: false,
      startDateInvalidRange:false,
      },
  ])
  const fieldMappingtwo = {
    "Q61.1.": {
        1: ["pre_oral", "trans_oral", "trans_dis_oral", "threeoral", "twelve_oral", "twentfour_oral"],
        2: ["pre_enteral", "trans_enteral", "trans_dis_enteral", "three_enteral", "twelve_enteral", "twentfour_enteral"],
        3: ["pre_parental", "trans_parental", "trans_dis_parental", "three_parental", "twelve_parental", "twentfour_parental"]
    }
  };
  const [nutritionData,setNutritionData]=useState({
    patientId:patientId,
    userId:GetLoggedInUserID(),
    //58
    "Q58.":{
    pretransplant_diet_date:null,//0th index
    pretransplant_diet_date_estimated:null,//0th index
    pretransplant_diet_date_picker:null,//0th index
    pretransplant_date_unknown:null,//0th index
    pretransplant_not_assessed:null,//0th index

    transplant_add_diet_date:null,//1st index
    transplant_add_diet_date_estimated:null,//1st index
    transplant_add_diet_date_picker:null,//1st index
    transplant_date_unknown:null,//1st index
    transplant_not_assessed:null,//1st index

    transplant_discharge_diet_date:null,//2 index
    transplant_discharge_diet_date_estimated:null,//2 index
    transplant_discharge_diet_date_picker:null,//2 index
    transplant_discharge_date_unknown:null,//2 index
    transplant_discharge_not_assessed:null,//2 index

    three_month_diet_date:null,//3 index
    three_month_diet_date_estimated:null,//3 index
    three_month_diet_date_picker:null,//3 index
    three_month_diet_date_unknown:null,//3 index
    three_month_diet_not_assessed:null,//3 index

    
    twelve_month_diet_date:null,//4 index
    twelve_month_diet_date_estimated:null,//4 index
    twelve_month_diet_date_picker:null,//4 index
    twelve_month_diet_date_unknown:null,//4 index
    twelve_month_diet_not_assessed:null,//4 index

    twentyfour_month_diet_date:null,//5 index
    twentyfour_month_diet_date_estimated:null,//5 index
    twentyfour_month_diet_date_picker:null,//5 index
    twentyfour_month_diet_date_unknown:null,//5 index
    twentyfour_month_diet_not_assessed:null,//5 index
    },

    "Q59.":{
    pretransplant_g:null,
    pretransplant_g_txt:null,
    pretransplant_kg:null,
    pretransplant_kg_txt:null,
    pretransplant_other:null,
    pretransplant_other_txt:null,
    pretransplant_unknown:null,

    transplant_admission_g:null,
    transplant_admission_g_txt:null,
    transplant_admission_kg:null,
    transplant_admission_kg_txt:null,
    transplant_admission_other:null,
    transplant_admission_other_txt:null,
    transplant_admission_unknown:null,

    transplant_discharge_g:null,
    transplant_discharge_g_txt:null,
    transplant_discharge_kg:null,
    transplant_discharge_kg_txt:null,
    transplant_discharge_other:null,
    transplant_discharge_other_txt:null,
    transplant_discharge_unknown:null,

    three_month_g:null,
    three_month_g_txt:null,
    three_month_kg:null,
    three_month_kg_txt:null,
    three_month_other:null,
    three_month_other_txt:null,
    three_month_unknown:null,

    twelve_month_g:null,
    twelve_month_g_txt:null,
    twelve_month_kg:null,
    twelve_month_kg_txt:null,
    twelve_month_other:null,
    twelve_month_other_txt:null,
    twelve_month_unknown:null,

    twentyfour_month_g:null,
    twentyfour_month_g_txt:null,
    twentyfour_month_kg:null,
    twentyfour_month_kg_txt:null,
    twentyfour_month_other:null,
    twentyfour_month_other_txt:null,
    twentyfour_month_unknown:null,},
    "Q59.1.":{
      pretransplant_g:null,
      pretransplant_g_txt:null,
      pretransplant_kg:null,
      pretransplant_kg_txt:null,
      pretransplant_other:null,
      pretransplant_other_txt:null,
      pretransplant_unknown:null,
  
      transplant_admission_g:null,
      transplant_admission_g_txt:null,
      transplant_admission_kg:null,
      transplant_admission_kg_txt:null,
      transplant_admission_other:null,
      transplant_admission_other_txt:null,
      transplant_admission_unknown:null,
  
      transplant_discharge_g:null,
      transplant_discharge_g_txt:null,
      transplant_discharge_kg:null,
      transplant_discharge_kg_txt:null,
      transplant_discharge_other:null,
      transplant_discharge_other_txt:null,
      transplant_discharge_unknown:null,
  
      three_month_g:null, 
      three_month_g_txt:null,
      three_month_kg:null,
      three_month_kg_txt:null, 
      three_month_other:null,
      three_month_other_txt:null,
      three_month_unknown:null,
  
      twelve_month_g:null,
      twelve_month_g_txt:null,
      twelve_month_kg:null,
      twelve_month_kg_txt:null,
      twelve_month_other:null,
      twelve_month_other_txt:null,
      twelve_month_unknown:null,
  
      twentyfour_month_g:null,
      twentyfour_month_g_txt:null,
      twentyfour_month_kg:null,
      twentyfour_month_kg_txt:null,
      twentyfour_month_other:null,
      twentyfour_month_other_txt:null,
      twentyfour_month_unknown:null,},

    "Q59.2.":{
        pretransplant_g:null,
        pretransplant_g_txt:null,
        pretransplant_kg:null,
        pretransplant_kg_txt:null,
        pretransplant_other:null,
        pretransplant_other_txt:null,
        pretransplant_unknown:null,
    
        transplant_admission_g:null,
        transplant_admission_g_txt:null,
        transplant_admission_kg:null,
        transplant_admission_kg_txt:null,
        transplant_admission_other:null,
        transplant_admission_other_txt:null,
        transplant_admission_unknown:null,
    
        transplant_discharge_g:null,
        transplant_discharge_g_txt:null,
        transplant_discharge_kg:null,
        transplant_discharge_kg_txt:null,
        transplant_discharge_other:null,
        transplant_discharge_other_txt:null,
        transplant_discharge_unknown:null,
    
        three_month_g:null,
        three_month_g_txt:null,
        three_month_kg:null,
        three_month_kg_txt:null,
        three_month_other:null,
        three_month_other_txt:null,
        three_month_unknown:null,
    
        twelve_month_g:null,
        twelve_month_g_txt:null,
        twelve_month_kg:null,
        twelve_month_kg_txt:null,
        twelve_month_other:null,
        twelve_month_other_txt:null,
        twelve_month_unknown:null,
    
        twentyfour_month_g:null,
        twentyfour_month_g_txt:null,
        twentyfour_month_kg:null,
        twentyfour_month_kg_txt :null,
        twentyfour_month_other:null,
        twentyfour_month_other_txt:null,
        twentyfour_month_unknown:null,},


     "Q60.":{
    pretransplant_k:null,
    pretransplant_k_txt:null,
    pretransplant_kc:null,
    pretransplant_kc_txt:null,
    pretransplant_other:null,
    pretransplant_other_txt:null,
    pretransplant_unknown:null,

    transplant_admission_k:null,
    transplant_admission_k_txt:null,
    transplant_admission_kc:null,
    transplant_admission_kc_txt:null,
    transplant_admission_other:null,
    transplant_admission_other_txt:null,
    transplant_admission_unknown:null,

    transplant_discharge_k:null,
    transplant_discharge_k_txt:null,
    transplant_discharge_kc:null,
    transplant_discharge_kc_txt:null,
    transplant_discharge_other:null,
    transplant_discharge_other_txt:null,
    transplant_discharge_unknown:null,

    three_month_k:null,
    three_month_k_txt:null,
    three_month_kc:null,
    three_month_kc_txt:null,
    three_month_other:null,
    three_month_other_txt:null,
    three_month_unknown:null,

    twelve_month_k:null,
    twelve_month_k_txt:null,
    twelve_month_kc:null,
    twelve_month_kc_txt:null,
    twelve_month_other:null,
    twelve_month_other_txt:null,
    twelve_month_unknown:null,

    twentyfour_month_k:null,
    twentyfour_month_k_txt:null,
    twentyfour_month_kc:null,
    twentyfour_month_kc_txt:null,
    twentyfour_month_other:null,
    twentyfour_month_other_txt:null,
    twentyfour_month_unknown:null,},
    
    
    "Q61.":{
    pretransplant_oral:null,
    pretransplant_eternal:null,
    pretransplant_parental:null,
    pretransplant_routes_unknown:null,

    transplant_admission_oral:null,
    transplant_admission_eternal:null,
    transplant_admission_parental:null,
    transplant_admission_routes_unknown:null,

    transplant_discharge_oral:null,
    transplant_discharge_eternal:null,
    transplant_discharge_parental:null,
    transplant_discharge_routes_unknown:null,

    three_month_oral:null,
    three_month_eternal:null,
    three_month_parental:null,
    three_month_routes_unknown:null,

    twelve_month_oral:null,
    twelve_month_eternal:null,
    twelve_month_parental:null,
    twelve_month_routes_unknown:null,

    twentyfour_month_oral:null,
    twentyfour_month_eternal:null,
    twentyfour_month_parental:null,
    twentyfour_month_routes_unknown:null,},

    "Q61.1.":{
      1:{
        pre_oral:null,
        trans_oral:null,
        trans_dis_oral:null,
        threeoral:null,
        twelve_oral:null,
        twentfour_oral:null,
      },
    

      2:{
        pre_enteral:null,
        trans_enteral:null,
        trans_dis_enteral:null,
        three_enteral:null,
        twelve_enteral:null,
        twentfour_enteral:null,
      },
      3:{
        pre_parental:null,
        trans_parental:null,
        trans_dis_parental:null,
        three_parental:null,
        twelve_parental:null,
        twentfour_parental:null,
      },
    },

    "Q62.":{
      pretransplant_yes:null,
      pretransplant_no:null,
      pretransplant_unknown:null,
      pretransplant_yes_partial:null, pretransplant_yes_total:null,
  
      transplant_admission_yes:null,
      transplant_admission_no:null,
      transplant_admission_unknown:null,
      transplant_admission_partial:null,transplant_admission_total:null,
  
      transplant_discharge_yes:null,
      transplant_discharge_no:null,
      transplant_discharge_unknown:null,
      transplant_discharge_partial:null,transplant_discharge_total:null,
  
      three_month_yes:null,
      three_month_no:null,
      three_month_unknown:null,
      three_month_partial:null,three_month_total:null,
  
      twelve_month_yes:null,
      twelve_month_no:null,
      twelve_month_unknown:null,
      twelve_month_partial:null,twelve_month_total:null,
  
      twentyfour_month_yes:null,
      twentyfour_month_no:null,
      twentyfour_month_unknown:null,
      twentyfour_month_partial:null,twentyfour_month_total:null},

      "Q63.":sickdayDietDetails,

  });
  const fieldMapping = {
    "Q58.":[
    ["pretransplant_diet_date",
    "pretransplant_diet_date_estimated",
    "pretransplant_diet_date_picker",
    "pretransplant_date_unknown",
    "pretransplant_not_assessed",],

    ["transplant_add_diet_date",
    "transplant_add_diet_date_estimated",
  "transplant_add_diet_date_picker",
  "transplant_date_unknown",
  "transplant_not_assessed",],

    ["transplant_discharge_diet_date",
    "transplant_discharge_diet_date_estimated",
  "transplant_discharge_diet_date_picker",
  "transplant_discharge_date_unknown",
    "transplant_discharge_not_assessed",],

    ["three_month_diet_date",
    "three_month_diet_date_estimated",
  "three_month_diet_date_picker",
  "three_month_diet_date_unknown",
  "three_month_diet_not_assessed",],

    
    ["twelve_month_diet_date",
    "twelve_month_diet_date_estimated",
  "twelve_month_diet_date_picker",
  "twelve_month_diet_date_unknown",
  "twelve_month_diet_not_assessed",],

    ["twentyfour_month_diet_date",
    "twentyfour_month_diet_date_estimated",
  "twentyfour_month_diet_date_picker",
  "twentyfour_month_diet_date_unknown",
  "twentyfour_month_diet_not_assessed",]],

    "Q59.":[
      [
    "pretransplant_g",
    "pretransplant_g_txt",
    "pretransplant_kg",
    "pretransplant_kg_txt",
    "pretransplant_other",
    "pretransplant_other_txt",
    "pretransplant_unknown"],

    ["transplant_admission_g",
      "transplant_admission_g_txt",
    "transplant_admission_kg",
    "transplant_admission_kg_txt",
    "transplant_admission_other",
    "transplant_admission_other_txt",
    "transplant_admission_unknown"],

    ["transplant_discharge_g",
      "transplant_discharge_g_txt",
    "transplant_discharge_kg",
    "transplant_discharge_kg_txt",
    "transplant_discharge_other",
    "transplant_discharge_other_txt",
    "transplant_discharge_unknown"],

    ["three_month_g",
      "three_month_g_txt",
    "three_month_kg",
    "three_month_kg_txt",
    "three_month_other",
    "three_month_other_txt",
    "three_month_unknown"],

    ["twelve_month_g",
      "twelve_month_g_txt",
    "twelve_month_kg",
    "twelve_month_kg_txt",
    "twelve_month_other",
    "twelve_month_other_txt",
    "twelve_month_unknown"],

    ["twentyfour_month_g",
      "twentyfour_month_g_txt",
    "twentyfour_month_kg",
    "twentyfour_month_kg_txt",
    "twentyfour_month_other",
    "twentyfour_month_other_txt",
    "twentyfour_month_unknown"]],
    "Q59.1.":[
     ["pretransplant_g",
      "pretransplant_g_txt",
      "pretransplant_kg",
      "pretransplant_kg_txt",
      "pretransplant_other",
      "pretransplant_other_txt",
      "pretransplant_unknown"],
  
      ["transplant_admission_g",
        "transplant_admission_g_txt",
      "transplant_admission_kg",
      "transplant_admission_kg_txt",
      "transplant_admission_other",
      "transplant_admission_other_txt",
      "transplant_admission_unknown"],
  
      ["transplant_discharge_g",
        "transplant_discharge_g_txt",
      "transplant_discharge_kg",
      "transplant_discharge_kg_txt",
      "transplant_discharge_other",
      "transplant_discharge_other_txt",
      "transplant_discharge_unknown"],
  
      ["three_month_g",
        "three_month_g_txt",
      "three_month_kg",
      "three_month_kg_txt",
      "three_month_other",
      "three_month_other_txt",
      "three_month_unknown"],
  
      ["twelve_month_g",
        "twelve_month_g_txt",
      "twelve_month_kg",
      "twelve_month_kg_txt",
      "twelve_month_other",
      "twelve_month_other_txt",
      "twelve_month_unknown"],
  
      ["twentyfour_month_g",
        "twentyfour_month_g_txt",
      "twentyfour_month_kg",
      "twentyfour_month_kg_txt",
      "twentyfour_month_other",
      "twentyfour_month_other_txt",
      "twentyfour_month_unknown"]],

    "Q59.2.":[
        ["pretransplant_g",
          "pretransplant_g_txt",
        "pretransplant_kg",
        "pretransplant_kg_txt",
        "pretransplant_other",
        "pretransplant_other_txt",
        "pretransplant_unknown"],
    
        ["transplant_admission_g",
          "transplant_admission_g_txt",
        "transplant_admission_kg",
        "transplant_admission_kg_txt",
        "transplant_admission_other",
        "transplant_admission_other_txt",
        "transplant_admission_unknown"],
    
        ["transplant_discharge_g",
          "transplant_discharge_g_txt",
        "transplant_discharge_kg",
        "transplant_discharge_kg_txt",
        "transplant_discharge_other",
        "transplant_discharge_other_txt",
        "transplant_discharge_unknown"],
    
        ["three_month_g",
          "three_month_g_txt",
        "three_month_kg",
        "three_month_kg_txt",
        "three_month_other",
        "three_month_other_txt",
        "three_month_unknown"],
    
        ["twelve_month_g",
          "twelve_month_g_txt",
        "twelve_month_kg",
        "twelve_month_kg_txt",
        "twelve_month_other",
        "twelve_month_other_txt",
        "twelve_month_unknown"],
    
        ["twentyfour_month_g",
          "twentyfour_month_g_txt",
        "twentyfour_month_kg",
        "twentyfour_month_kg_txt",
        "twentyfour_month_other",
        "twentyfour_month_other_txt",
        "twentyfour_month_unknown"]],

        "Q60.":[
          ["pretransplant_k",
            "pretransplant_k_txt",
          "pretransplant_kc",
          "pretransplant_kc_txt",
          "pretransplant_other",
          "pretransplant_other_txt",
          "pretransplant_unknown"],
      
          ["transplant_admission_k",
            "transplant_admission_k_txt",
          "transplant_admission_kc",
          "transplant_admission_kc_txt",
          "transplant_admission_other",
          "transplant_admission_other_txt",
          "transplant_admission_unknown"],
      
          ["transplant_discharge_k",
            "transplant_discharge_k_txt",
          "transplant_discharge_kc",
          "transplant_discharge_kc_txt",
          "transplant_discharge_other",
          "transplant_discharge_other_txt",
          "transplant_discharge_unknown"],
      
          ["three_month_k",
            "three_month_k_txt",
          "three_month_kc",
          "three_month_kc_txt",
          "three_month_other",
          "three_month_other_txt",
          "three_month_unknown"],
      
          ["twelve_month_k",
            "twelve_month_k_txt",
          "twelve_month_kc",
          "twelve_month_kc_txt",
          "twelve_month_other",
          "twelve_month_other_txt",
          "twelve_month_unknown"],
      
          ["twentyfour_month_k",
            "twentyfour_month_k_txt",
          "twentyfour_month_kc",
          "twentyfour_month_kc_txt",
          "twentyfour_month_other",
          "twentyfour_month_other_txt",
          "twentyfour_month_unknown",]],
          

    "Q61.":[

    ["pretransplant_oral",
    "pretransplant_eternal",
    "pretransplant_parental",
    "pretransplant_routes_unknown"],

    ["transplant_admission_oral",
    "transplant_admission_eternal",
    "transplant_admission_parental",
    "transplant_admission_routes_unknown"],

    ["transplant_discharge_oral",
    "transplant_discharge_eternal",
    "transplant_discharge_parental",
    "transplant_discharge_routes_unknown"],

    ["three_month_oral",
    "three_month_eternal",
    "three_month_parental",
    "three_month_routes_unknown"],

    ["twelve_month_oral",
    "twelve_month_eternal",
    "twelve_month_parental",
    "twelve_month_routes_unknown"],

    ["twentyfour_month_oral",
    "twentyfour_month_eternal",
    "twentyfour_month_parental",
    "twentyfour_month_routes_unknown"]],
    "Q61.1.":{
      1:[
        "pre_oral" ,
        "trans_oral" ,
        "trans_dis_oral" ,
        "threeoral" ,
        "twelve_oral" ,
        "twentfour_oral" ,
      ],
    

      2:[
        "pre_enteral" ,
        "trans_enteral" ,
        "trans_dis_enteral" ,
        "three_enteral" ,
        "twelve_enteral" ,
        "twentfour_enteral" ,
      ],
      3:[
        "pre_parental" ,
        "trans_parental" ,
        "trans_dis_parental" ,
        "three_parental" ,
        "twelve_parental" ,
        "twentfour_parental" ,
      ],
    },

    "Q62.":[
      ["pretransplant_yes",
      "pretransplant_no",
      "pretransplant_unknown",
      "pretransplant_yes_partial", "pretransplant_yes_total"],
  
      ["transplant_admission_yes",
      "transplant_admission_no",
      "transplant_admission_unknown",
      "transplant_admission_partial","transplant_admission_total"],
  
      ["transplant_discharge_yes",
      "transplant_discharge_no",
      "transplant_discharge_unknown",
      "transplant_discharge_partial","transplant_discharge_total"],
  
      ["three_month_yes",
      "three_month_no",
      "three_month_unknown",
      "three_month_partial","three_month_total"],
  
      ["twelve_month_yes",
      "twelve_month_no",
      "twelve_month_unknown",
      "twelve_month_partial","twelve_month_total"],
  
      ["twentyfour_month_yes",
      "twentyfour_month_no",
      "twentyfour_month_unknown",
      "twentyfour_month_partial","twentyfour_month_total"],]
    };
    const [nutritionError,setNutritionError]=useState({ })
    const { ShowToast, ToggleLoader, HandleSessionTimeout,isSideMenuActive, setisSideMenuActive} =
    useContext(AppContext);
    const [infoPopUpModal,setInfoPopUpModal]=useState(false);
    const [description,setDescription]=useState("");
    const navigatePaths = {
        prevPage: "/MMARelatedComplications",
        currPage: "/NutritionManagement",
        nextPage: (locked && submit === 2) ? "/ValidateSubmit?part=2" : "",
    };
  

  const Validate = () => {
    let isValid = true;
   
    
    //const errors = Array(6).fill(false); // Temporary array to store validation results
    const errors = Array(6).fill(null).map(() => ({
      missingValues: false,
      invalidRange: false
    }));
     
    const errors59 = Array(6).fill(null).map(() => ({
      missingValues: false,
      invalidRange: false
    }));
    const errors591 = Array(6).fill(null).map(() => ({
      missingValues: false,
      invalidRange: false
    }));
     const errors592 = Array(6).fill(null).map(() => ({
      missingValues: false,
      invalidRange: false
    }));
    const errors60 = Array(6).fill(null).map(() => ({
      missingValues: false,
      invalidRange: false
    }));
    const errors61 = Array(6).fill(false); // Temporary array to store validation results
    const errors611 = {
      1: Array(6).fill(false), 
      2: Array(6).fill(false), 
      3: Array(6).fill(false)
  };   
  const errors62 = Array(6).fill(null).map(() => ({
    missingValues: false,
    invalidRange: false
  }));

  const notAssessedFields = [
    "pretransplant_not_assessed",
    "transplant_not_assessed",
    "transplant_discharge_not_assessed",
    "three_month_diet_not_assessed",
    "twelve_month_diet_not_assessed",
    "twentyfour_month_diet_not_assessed"
  ];

    const fieldGroups = [
      ["pretransplant_diet_date", "pretransplant_diet_date_estimated", "pretransplant_diet_date_picker", "pretransplant_date_unknown", "pretransplant_not_assessed"],
      ["transplant_add_diet_date", "transplant_add_diet_date_estimated", "transplant_add_diet_date_picker", "transplant_date_unknown", "transplant_not_assessed"],
      ["transplant_discharge_diet_date", "transplant_discharge_diet_date_estimated", "transplant_discharge_diet_date_picker", "transplant_discharge_date_unknown", "transplant_discharge_not_assessed"],
      ["three_month_diet_date", "three_month_diet_date_estimated", "three_month_diet_date_picker", "three_month_diet_date_unknown", "three_month_diet_not_assessed"],
      ["twelve_month_diet_date", "twelve_month_diet_date_estimated", "twelve_month_diet_date_picker", "twelve_month_diet_date_unknown", "twelve_month_diet_not_assessed"],
      ["twentyfour_month_diet_date", "twentyfour_month_diet_date_estimated", "twentyfour_month_diet_date_picker", "twentyfour_month_diet_date_unknown", "twentyfour_month_diet_not_assessed"]
    ];
    fieldGroups.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      const groupData = nutritionData["Q58."];

      const allNull = fields.every(field => nutritionData["Q58."][field] === null || 
        nutritionData["Q58."][field] === undefined || 
        nutritionData["Q58."][field] === "" || 
        nutritionData["Q58."][field] === false
      );
  
      if (allNull) {
        errors[index].missingValues = true; // Set error if all fields are null
        isValid = false;
      }
      const baseName = fields[0]; // like pretransplant_diet_date
      const pickerName = fields[2]; // like pretransplant_diet_date_picker
  
      if (groupData[baseName] === true && 
          (groupData[pickerName] === null || groupData[pickerName] === undefined || groupData[pickerName] === "")
      ) {
        errors[index].invalidRange = true;
        isValid = false;
      }
    });
      const q59Fields = [
      ["pretransplant_g", "pretransplant_g_txt", "pretransplant_kg", "pretransplant_kg_txt", "pretransplant_other", "pretransplant_other_txt", "pretransplant_unknown"],
      ["transplant_admission_g", "transplant_admission_g_txt", "transplant_admission_kg", "transplant_admission_kg_txt", "transplant_admission_other", "transplant_admission_other_txt", "transplant_admission_unknown"],
      ["transplant_discharge_g", "transplant_discharge_g_txt", "transplant_discharge_kg", "transplant_discharge_kg_txt", "transplant_discharge_other", "transplant_discharge_other_txt", "transplant_discharge_unknown"],
      ["three_month_g", "three_month_g_txt", "three_month_kg", "three_month_kg_txt", "three_month_other", "three_month_other_txt", "three_month_unknown"],
      ["twelve_month_g", "twelve_month_g_txt", "twelve_month_kg", "twelve_month_kg_txt", "twelve_month_other", "twelve_month_other_txt", "twelve_month_unknown"],
      ["twentyfour_month_g", "twentyfour_month_g_txt", "twentyfour_month_kg", "twentyfour_month_kg_txt", "twentyfour_month_other", "twentyfour_month_other_txt", "twentyfour_month_unknown"]
    ];
    q59Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const [g, g_txt, kg, kg_txt, other, other_txt] = fields;

      const allNull = fields.every(field => nutritionData["Q59."][field] === null || 
        nutritionData["Q59."][field] === 0 || 
        nutritionData["Q59."][field] === undefined || 
        nutritionData["Q59."][field] === "" || 
        nutritionData["Q59."][field] === false
      );

    const valueAtIndex1 = parseFloat(nutritionData["Q59."][fields[1]]) || 0;
    const valueAtIndex3 = parseFloat(nutritionData["Q59."][fields[3]]) || 0;

    if (allNull) {
      errors59[index].missingValues = true;
      isValid = false;
    }
    if (valueAtIndex1 > 450 || valueAtIndex3 > 6) {
      errors59[index].invalidRange = true;
      isValid = false;
    }
    if (
      (nutritionData["Q59."][g] === true && (!nutritionData["Q59."][g_txt] || parseFloat(nutritionData["Q59."][g_txt]) === 0)) ||
      (nutritionData["Q59."][kg] === true && (!nutritionData["Q59."][kg_txt] || parseFloat(nutritionData["Q59."][kg_txt]) === 0)) ||
      (nutritionData["Q59."][other] === true && (!nutritionData["Q59."][other_txt] || parseFloat(nutritionData["Q59."][other_txt]) === 0))
    ) {
      errors59[index].missingValues = true;
      isValid = false;
    }
  });
    const q591Fields = [
      ["pretransplant_g", "pretransplant_g_txt", "pretransplant_kg", "pretransplant_kg_txt", "pretransplant_other", "pretransplant_other_txt", "pretransplant_unknown"],
      ["transplant_admission_g", "transplant_admission_g_txt", "transplant_admission_kg", "transplant_admission_kg_txt", "transplant_admission_other", "transplant_admission_other_txt", "transplant_admission_unknown"],
      ["transplant_discharge_g", "transplant_discharge_g_txt", "transplant_discharge_kg", "transplant_discharge_kg_txt", "transplant_discharge_other", "transplant_discharge_other_txt", "transplant_discharge_unknown"],
      ["three_month_g", "three_month_g_txt", "three_month_kg", "three_month_kg_txt", "three_month_other", "three_month_other_txt", "three_month_unknown"],
      ["twelve_month_g", "twelve_month_g_txt", "twelve_month_kg", "twelve_month_kg_txt", "twelve_month_other", "twelve_month_other_txt", "twelve_month_unknown"],
      ["twentyfour_month_g", "twentyfour_month_g_txt", "twentyfour_month_kg", "twentyfour_month_kg_txt", "twentyfour_month_other", "twentyfour_month_other_txt", "twentyfour_month_unknown"]
    ];
    q591Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      } 
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const [g, g_txt, kg, kg_txt, other, other_txt] = fields;

      const allNull = fields.every(field => nutritionData["Q59.1."][field] === null || 
        nutritionData["Q59.1."][field] === undefined || 
        nutritionData["Q59.1."][field] === "" || 
        nutritionData["Q59.1."][field] === false
      );
    
      const valueAtIndex1 = parseFloat(nutritionData["Q59.1."][fields[1]]) || 0;
      const valueAtIndex3 = parseFloat(nutritionData["Q59.1."][fields[3]]) || 0;
    
      if (allNull) {
        errors591[index].missingValues = true;
        isValid = false;
      }
      if (valueAtIndex1 > 450 || valueAtIndex3 > 6) {
        errors591[index].invalidRange = true;
        isValid = false;
      }
      if (
        (nutritionData["Q59.1."][g] === true && (!nutritionData["Q59.1."][g_txt] || parseFloat(nutritionData["Q59.1."][g_txt]) === 0)) ||
        (nutritionData["Q59.1."][kg] === true && (!nutritionData["Q59.1."][kg_txt] || parseFloat(nutritionData["Q59.1."][kg_txt]) === 0)) ||
        (nutritionData["Q59.1."][other] === true && (!nutritionData["Q59.1."][other_txt] || parseFloat(nutritionData["Q59.1."][other_txt]) === 0))
      ) {
        errors591[index].missingValues = true;
        isValid = false;
      }
    });
    const q592Fields = [
      ["pretransplant_g", "pretransplant_g_txt", "pretransplant_kg", "pretransplant_kg_txt", "pretransplant_other", "pretransplant_other_txt", "pretransplant_unknown"],
      ["transplant_admission_g", "transplant_admission_g_txt", "transplant_admission_kg", "transplant_admission_kg_txt", "transplant_admission_other", "transplant_admission_other_txt", "transplant_admission_unknown"],
      ["transplant_discharge_g", "transplant_discharge_g_txt", "transplant_discharge_kg", "transplant_discharge_kg_txt", "transplant_discharge_other", "transplant_discharge_other_txt", "transplant_discharge_unknown"],
      ["three_month_g", "three_month_g_txt", "three_month_kg", "three_month_kg_txt", "three_month_other", "three_month_other_txt", "three_month_unknown"],
      ["twelve_month_g", "twelve_month_g_txt", "twelve_month_kg", "twelve_month_kg_txt", "twelve_month_other", "twelve_month_other_txt", "twelve_month_unknown"],
      ["twentyfour_month_g", "twentyfour_month_g_txt", "twentyfour_month_kg", "twentyfour_month_kg_txt", "twentyfour_month_other", "twentyfour_month_other_txt", "twentyfour_month_unknown"]
    ];
    q592Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const [g, g_txt, kg, kg_txt, other, other_txt] = fields;

      const allNull = fields.every(field => nutritionData["Q59.2."][field] === null || 
        nutritionData["Q59.2."][field] === undefined || 
        nutritionData["Q59.2."][field] === "" || 
        nutritionData["Q59.2."][field] === false
      );
  
      const valueAtIndex1 = parseFloat(nutritionData["Q59.2."][fields[1]]) || 0;
      const valueAtIndex3 = parseFloat(nutritionData["Q59.2."][fields[3]]) || 0;
   
      if (allNull) {
        errors592[index].missingValues = true;
        isValid = false;
      }
      if (valueAtIndex1 > 450 || valueAtIndex3 > 6) {
        errors592[index].invalidRange = true;
        isValid = false;
      }
      if (
      (nutritionData["Q59.2."][g] === true && (!nutritionData["Q59.2."][g_txt] || parseFloat(nutritionData["Q59.2."][g_txt]) === 0)) ||
      (nutritionData["Q59.2."][kg] === true && (!nutritionData["Q59.2."][kg_txt] || parseFloat(nutritionData["Q59.2."][kg_txt]) === 0)) ||
      (nutritionData["Q59.2."][other] === true && (!nutritionData["Q59.2."][other_txt] || parseFloat(nutritionData["Q59.2."][other_txt]) === 0))
    ) {
      errors592[index].missingValues = true;
      isValid = false;
    }
    });
    const q60Fields = [
      ["pretransplant_k", "pretransplant_k_txt", "pretransplant_kc", "pretransplant_kc_txt", "pretransplant_other", "pretransplant_other_txt", "pretransplant_unknown"],
      ["transplant_admission_k", "transplant_admission_k_txt", "transplant_admission_kc", "transplant_admission_kc_txt", "transplant_admission_other", "transplant_admission_other_txt", "transplant_admission_unknown"],
      ["transplant_discharge_k", "transplant_discharge_k_txt", "transplant_discharge_kc", "transplant_discharge_kc_txt", "transplant_discharge_other", "transplant_discharge_other_txt", "transplant_discharge_unknown"],
      ["three_month_k", "three_month_k_txt", "three_month_kc", "three_month_kc_txt", "three_month_other", "three_month_other_txt", "three_month_unknown"],
      ["twelve_month_k", "twelve_month_k_txt", "twelve_month_kc", "twelve_month_kc_txt", "twelve_month_other", "twelve_month_other_txt", "twelve_month_unknown"],
      ["twentyfour_month_k", "twentyfour_month_k_txt", "twentyfour_month_kc", "twentyfour_month_kc_txt", "twentyfour_month_other", "twentyfour_month_other_txt", "twentyfour_month_unknown"]
    ];
     
    q60Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const [k, k_txt, kc, kc_txt, other, other_txt] = fields;

      const allNull = fields.every(field => 
        nutritionData["Q60."][field] === null || 
        nutritionData["Q60."][field] === undefined || 
        nutritionData["Q60."][field] === "" || 
        nutritionData["Q60."][field] === false
      );
      
      // Additional validations
      const valueAtIndex1 = parseFloat(nutritionData["Q60."][fields[1]]) || 0;
      const valueAtIndex3 = parseFloat(nutritionData["Q60."][fields[3]]) || 0;
      
      if (allNull) {
        errors60[index].missingValues = true;
        isValid = false;
      }
      if (valueAtIndex1 > 9000 || valueAtIndex3 > 300) {
        errors60[index].invalidRange = true;
        isValid = false;
      }
      if (
        (nutritionData["Q60."][k] === true && (!nutritionData["Q60."][k_txt] || parseFloat(nutritionData["Q60."][k_txt]) === 0)) ||
        (nutritionData["Q60."][kc] === true && (!nutritionData["Q60."][kc_txt] || parseFloat(nutritionData["Q60."][kc_txt]) === 0)) ||
        (nutritionData["Q60."][other] === true && (!nutritionData["Q60."][other_txt] || parseFloat(nutritionData["Q60."][other_txt]) === 0))
      ) {
        errors60[index].missingValues = true;
        isValid = false;
      }
    });
    const q61Fields = [
      ["pretransplant_oral", "pretransplant_eternal", "pretransplant_parental", "pretransplant_routes_unknown"],
      ["transplant_admission_oral", "transplant_admission_eternal", "transplant_admission_parental", "transplant_admission_routes_unknown"],
      ["transplant_discharge_oral", "transplant_discharge_eternal", "transplant_discharge_parental", "transplant_discharge_routes_unknown"],
      ["three_month_oral", "three_month_eternal", "three_month_parental", "three_month_routes_unknown"],
      ["twelve_month_oral", "twelve_month_eternal", "twelve_month_parental", "twelve_month_routes_unknown"],
      ["twentyfour_month_oral", "twentyfour_month_eternal", "twentyfour_month_parental", "twentyfour_month_routes_unknown"]
    ];
    q61Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const allNull = fields.every(field => nutritionData["Q61."][field] === null || 
        nutritionData["Q61."][field] === undefined || 
        nutritionData["Q61."][field] === "" || 
        nutritionData["Q61."][field] === false
      );
  
      if (allNull) {
        errors61[index] = true; // Set error if all fields are null
        isValid = false;
      }
    });

    if(nutritionData["Q61."].pretransplant_oral===true 
      &&(nutritionData["Q61."].pretransplant_parental===true || nutritionData["Q61."].pretransplant_eternal===true)
       && nutritionData["Q61.1."][1].pre_oral===null){
      
      errors611[1][0] = true; 
      isValid = false;
    }
    if(nutritionData["Q61."].transplant_admission_oral===true
      &&(nutritionData["Q61."].transplant_admission_parental===true || nutritionData["Q61."].transplant_admission_eternal===true)
       && nutritionData["Q61.1."][1].trans_oral===null){
      errors611[1][1] = true; 
      isValid = false;
    } 
    if(nutritionData["Q61."].transplant_discharge_oral===true 
      &&(nutritionData["Q61."].transplant_discharge_parental===true || nutritionData["Q61."].transplant_discharge_eternal===true)
       && nutritionData["Q61.1."][1].trans_dis_oral===null){
              errors611[1][2] = true; 
              isValid = false;

    } 
    if(nutritionData["Q61."].three_month_oral===true
      &&(nutritionData["Q61."].three_month_parental===true || nutritionData["Q61."].three_month_eternal===true)
        && nutritionData["Q61.1."][1].threeoral===null){
              errors611[1][3] = true;
              isValid = false;

    } 
    if(nutritionData["Q61."].twelve_month_oral===true
      &&(nutritionData["Q61."].twelve_month_parental===true || nutritionData["Q61."].twelve_month_eternal===true)
        && nutritionData["Q61.1."][1].twelve_oral===null){
              errors611[1][4] = true; 
              isValid = false;

    } 
    if(nutritionData["Q61."].twentyfour_month_oral===true 
      &&(nutritionData["Q61."].twentyfour_month_parental===true || nutritionData["Q61."].twentyfour_month_eternal===true)
       && nutritionData["Q61.1."][1].twentfour_oral===null){

              errors611[1][5] = true; 
              isValid = false;

    }
    //2nd row for 61.1
    if(nutritionData["Q61."].pretransplant_eternal===true
      &&(nutritionData["Q61."].pretransplant_parental===true || nutritionData["Q61."].pretransplant_oral===true)
      && nutritionData["Q61.1."][2].pre_enteral===null){
      errors611[2][0] = true; 
      isValid = false;
    }
    if(nutritionData["Q61."].transplant_admission_eternal===true
      &&(nutritionData["Q61."].transplant_admission_parental===true || nutritionData["Q61."].transplant_admission_oral===true)
      && nutritionData["Q61.1."][2].trans_enteral===null){
      errors611[2][1] = true; 
      isValid = false;
    } 
    if(nutritionData["Q61."].transplant_discharge_eternal===true
      &&(nutritionData["Q61."].transplant_discharge_parental===true || nutritionData["Q61."].transplant_discharge_oral===true)
      && nutritionData["Q61.1."][2].trans_dis_enteral===null){
              errors611[2][2] = true; 
              isValid = false;

    } 
    if(nutritionData["Q61."].three_month_eternal===true
      &&(nutritionData["Q61."].three_month_parental===true || nutritionData["Q61."].three_month_oral===true)
      && nutritionData["Q61.1."][2].three_enteral===null){
              errors611[2][3] = true;
              isValid = false;

    } 
    if(nutritionData["Q61."].twelve_month_eternal===true
      &&(nutritionData["Q61."].twelve_month_parental===true || nutritionData["Q61."].twelve_month_oral===true)
      && nutritionData["Q61.1."][2].twelve_enteral===null){
              errors611[2][4] = true; 
              isValid = false;

    } 
    if(nutritionData["Q61."].twentyfour_month_eternal===true
      &&(nutritionData["Q61."].twentyfour_month_parental===true || nutritionData["Q61."].twentyfour_month_oral===true)
      && nutritionData["Q61.1."][2].twentfour_enteral===null){
              errors611[2][5] = true; 
              isValid = false;

    }
//3rd row for 61.1
if(nutritionData["Q61."].pretransplant_parental===true
  &&(nutritionData["Q61."].pretransplant_eternal===true || nutritionData["Q61."].pretransplant_oral===true)
  && nutritionData["Q61.1."][3].pre_parental===null){
  errors611[3][0] = true; 
  isValid = false;
}
if(nutritionData["Q61."].transplant_admission_parental===true
  &&(nutritionData["Q61."].transplant_admission_eternal===true || nutritionData["Q61."].transplant_admission_oral===true)
  && nutritionData["Q61.1."][3].trans_parental===null){
  errors611[3][1] = true; 
  isValid = false;
} 
if(nutritionData["Q61."].transplant_discharge_parental===true
  &&(nutritionData["Q61."].transplant_discharge_eternal===true || nutritionData["Q61."].transplant_discharge_oral===true)
  && nutritionData["Q61.1."][3].trans_dis_parental===null){
          errors611[3][2] = true;
          isValid = false; 

} 
if(nutritionData["Q61."].three_month_parental===true
  &&(nutritionData["Q61."].three_month_eternal===true || nutritionData["Q61."].three_month_oral===true)
  && nutritionData["Q61.1."][3].three_parental===null){
          errors611[3][3] = true;
          isValid = false;

} 
if(nutritionData["Q61."].twelve_month_parental===true 
  &&(nutritionData["Q61."].twelve_month_eternal===true || nutritionData["Q61."].twelve_month_oral===true)
  && nutritionData["Q61.1."][3].twelve_parental===null){
          errors611[3][4] = true; 
          isValid = false;

} 
if(nutritionData["Q61."].twentyfour_month_parental===true
  &&(nutritionData["Q61."].twentyfour_month_oral===true || nutritionData["Q61."].twentyfour_month_eternal===true)
  && nutritionData["Q61.1."][3].twentfour_parental===null){
          errors611[3][5] = true; 
          isValid = false;

}
    const q62Fields = [
      ["pretransplant_yes", "pretransplant_no", "pretransplant_unknown","pretransplant_yes_partial", "pretransplant_yes_total"],
      ["transplant_admission_yes", "transplant_admission_no", "transplant_admission_unknown","transplant_admission_partial","transplant_admission_total"],
      ["transplant_discharge_yes", "transplant_discharge_no", "transplant_discharge_unknown","transplant_discharge_partial","transplant_discharge_total"],
      ["three_month_yes", "three_month_no", "three_month_unknown","three_month_partial","three_month_total"],
      ["twelve_month_yes", "twelve_month_no", "twelve_month_unknown","twelve_month_partial","twelve_month_total"],
      ["twentyfour_month_yes", "twentyfour_month_no", "twentyfour_month_unknown","twentyfour_month_partial","twentyfour_month_total"]
    ];
    q62Fields.forEach((fields, index) => {
      if (!hideMainColumns[index]) {
        return;
      }
      if (nutritionData["Q58."][notAssessedFields[index]]) {
        return; // Skip validation for this index
      }
      const [yesField, , , partialField, totalField] = fields;

      const allNull = fields.every(field => nutritionData["Q62."][field] === null || 
        nutritionData["Q62."][field] === undefined || 
        nutritionData["Q62."][field] === "" || 
        nutritionData["Q62."][field] === false
      );
  
      if (allNull) {
        errors62[index].missingValues = true; // Set error if all fields are null
        isValid = false;
      }
      if (nutritionData["Q62."][yesField] === true) {
        const hasPartialOrTotal = nutritionData["Q62."][partialField] === true || nutritionData["Q62."][totalField] === true;
        if (!hasPartialOrTotal) {
          errors62[index].invalidRange = true;
          isValid = false;
        }
      }
    });
    
    let errors63 = {};

    const skipQ63Validation = Number(sickdayDietDetails?.[0]?.startVisit) === 1;
    if (skipQ63Validation) {
      // Set all errors to false
      sickdayDietDetails?.forEach(row => {
        const sickid = row.sickid;
        errors63[sickid] = {
          startDateInvalid: false,
          endDateInvalid: false,
          cosDietaryInvalid: false,
          rfdInvalid: false,
          startDateInvalidRange:false
        };
      });
    } else {
      const pre=new Date(dates?.oneYr_pretransplant_start); //format=>mm/dd/yyyy =>"12/14/2021"
      const post=new Date(dates?.twenty_four_months_post_stabilization);//format=>mm/dd/yyyy => //"03/11/2023"

     errors63 = sickdayDietDetails?.reduce((acc, row) => {
      const sickid = row.sickid; // Use sickid from backend
      const startDate = row?.start_dt ? new Date(row.start_dt) : null;

      acc[sickid] = {
          startDateInvalid: (Number(row?.startVisit) !== 99 && (row.start_dt === "" || row.start_dt === null)), // Validate start date
          endDateInvalid: (row?.ongoingVisit != 99 && (row.end_dt === "" || row.end_dt === null)), // Validate end date
          startDateInvalidRange:
          Number(row?.startVisit) !== 99 &&
          startDate &&
          (startDate < pre || startDate > post),
          cosDietaryInvalid: !(
              row.cosDietary ||
              row.cosDietaryCalory ||
              row.cosDietaryProtien ||
              row.cosDietaryProtienZero ||
              row.cosDietaryCarb ||
              row.cosDietaryLipid ||
              row.cosDietaryUnknown ||
              row.modidfied ||
              row.modifiedNo ||
              row.modifiedParental ||
              row.modifiedEnteral ||
              row.modifiedUnknown ||
              row.cosIncreased ||
              row.cosMiscro ||
              row.cosOther ||
              row.cosUnknown
          ), // At least one dietary option should be selected

          rfdInvalid: !(
              row.rfdAfter ||
              row.rfdDuring ||
              row.rfdMitigation ||
              row.rfdOtherMedical ||
              row.rfdOtherMedical_txt ||
              row.rfdOtherReason ||
              row.rfdOtherReason_txt ||
              row.rfdRenal ||
              row.rfdUnknown
          ) // At least one RFD option should be selected
      };

      return acc;
  }, {});
    }
  // If any errors exist in Q63, set isValid to false
  if (Object.values(errors63).some(errorRow => Object.values(errorRow).includes(true))) {
      isValid = false;
  }

    setNutritionError(prevState => ({
      ...prevState,
      "Q58.": errors,
      "Q59.":errors59,
      "Q59.1.":errors591,
      "Q59.2.":errors592,
      "Q60.":errors60,
      "Q61.":errors61,
     "Q61.1.":errors611,
      "Q62.":errors62,
      "Q63.":{ 
        ...(prevState["Q63."] || {}), // Preserve existing errors
        ...errors63 // Update errors for current sickIds
    }


      

    }));
    return isValid;
  };
  const SavePage = async (validate) => {
      try {
          if (!patientLocked) {
              let isValid = validate ? Validate() : true;

              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);
              ToggleLoader(true);
              console.log(nutritionData["Q58."].twentyfour_month_diet_not_assessed);
              const payload = {

                  Q58: {
                      PretransplantDietDate: nutritionData["Q58."].pretransplant_diet_date,
                      PretransplantDietDateEstimated: nutritionData["Q58."].pretransplant_diet_date_estimated,
                      PretransplantDietDatePicker: nutritionData["Q58."].pretransplant_diet_date_picker,
                      PretransplantDietDateColumn: nutritionData["Q58."].pretransplant_date_unknown ? Values.value99 :
                          nutritionData["Q58."].pretransplant_not_assessed ? Values.value2 :
                              nutritionData["Q58."].pretransplant_diet_date ? Values.value1 :
                                  null,


                      TransplantDietDate: nutritionData["Q58."].transplant_add_diet_date,
                      TransplantDietDateEstimated: nutritionData["Q58."].transplant_add_diet_date_estimated,
                      TransplantDietDatePicker: nutritionData["Q58."].transplant_add_diet_date_picker,

                      TransplantDietDateColumn: nutritionData["Q58."].transplant_date_unknown ? Values.value99 :
                          nutritionData["Q58."].transplant_not_assessed ? Values.value2 :
                              nutritionData["Q58."].transplant_add_diet_date ? Values.value1 : null,

                      TransplantDischargeDietDate: nutritionData["Q58."].transplant_discharge_diet_date,
                      TransplantDischargeDietDateEstimated: nutritionData["Q58."].transplant_discharge_diet_date_estimated,
                      TransplantDischargeDietDatePicker: nutritionData["Q58."].transplant_discharge_diet_date_picker,
                      TransplantDischargeDietDateColumn: nutritionData["Q58."].transplant_discharge_date_unknown ? Values.value99 :
                          nutritionData["Q58."].transplant_discharge_not_assessed ? Values.value2 :
                              nutritionData["Q58."].transplant_discharge_diet_date ? Values.value1 : null,


                      ThreeMonthDietDate: nutritionData["Q58."].three_month_diet_date,
                      ThreeMonthDietDateEstimated: nutritionData["Q58."].three_month_diet_date_estimated,
                      ThreeMonthDietDatePicker: nutritionData["Q58."].three_month_diet_date_picker,

                      ThreeMonthDateDietDateColumn: nutritionData["Q58."].three_month_diet_date_unknown ? Values.value99 :
                          nutritionData["Q58."].three_month_diet_not_assessed ? Values.value2 :
                              nutritionData["Q58."].three_month_diet_date ? Values.value1 : null,

                      TwelveMonthDietDate: nutritionData["Q58."].twelve_month_diet_date,
                      TwelveMonthDietDateEstimated: nutritionData["Q58."].twelve_month_diet_date_estimated,
                      TwelveMonthDietDatePicker: nutritionData["Q58."].twelve_month_diet_date_picker,
                      TwelveMonthDietDateColumn: nutritionData["Q58."].twelve_month_diet_date_unknown ? Values.value99 :
                          nutritionData["Q58."].twelve_month_diet_not_assessed ? Values.value2 :
                              nutritionData["Q58."].twelve_month_diet_date ? Values.value1 : null,


                      TwentyfourMonthDietDate: nutritionData["Q58."].pretransplant_diet_date,
                      TwentyfourMonthDietDateEstimated: nutritionData["Q58."].twentyfour_month_diet_date_estimated,
                      TwentyfourMonthDietDatePicker: nutritionData["Q58."].twentyfour_month_diet_date_picker,
                      TwentyfourDietDateColumn: nutritionData["Q58."].twentyfour_month_diet_date_unknown ? Values.value99 :
                          nutritionData["Q58."].twentyfour_month_diet_not_assessed ? Values.value2 :
                              nutritionData["Q58."].twentyfour_month_diet_date ? Values.value1 : null,

                  },

                  Q59: {
                      PretransplantG: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_g,
                      PretransplantGText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_g_txt ? Number(nutritionData["Q59."].pretransplant_g_txt) : null,
                      PretransplantKg: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_kg,
                      PretransplantKgText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_kg_txt ? Number(nutritionData["Q59."].pretransplant_kg_txt) : null,
                      PretransplantOther: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_other,
                      PretransplantOtherText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].pretransplant_other_txt,
                      PretransplantUnknown: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : (nutritionData["Q59."].pretransplant_unknown === true ||
                          nutritionData["Q59."].transplant_admission_unknown === 99) ? Values.value99 : null,

                      TransplantAdmissionG: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_g,
                      TransplantAdmissionGText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_g_txt,
                      TransplantAdmissionKg: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_kg,
                      TransplantAdmissionKgText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_kg_txt,
                      TransplantAdmissionOther: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_other,
                      TransplantAdmissionOtherText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_admission_other_txt,
                      TransplantAdmissionUnknown: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : (nutritionData["Q59."].transplant_admission_unknown === true
                          || nutritionData["Q59."].transplant_admission_unknown === 99) ? Values.value99 : null,


                      TransplantDischargeG: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_g,
                      TransplantDischargeGText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_g_txt,
                      TransplantDischargeKg: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_kg,
                      TransplantDischargeKgText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_kg_txt,
                      TransplantDischargeOther: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_other,
                      TransplantDischargeOtherText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59."].transplant_discharge_other_txt,
                      TransplantDischargeUnknown: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : (nutritionData["Q59."].transplant_discharge_unknown === true ||
                          nutritionData["Q59."].transplant_discharge_unknown === 99) ? Values.value99 : null,

                      ThreeMonthG: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_g,
                      ThreeMonthGText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_g_txt,
                      ThreeMonthKg: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_kg,
                      ThreeMonthKgText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_kg_txt,
                      ThreeMonthOther: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_other,
                      ThreeMonthOtherText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].three_month_other_txt,
                      ThreeMonthUnknown: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59."].three_month_unknown === true ||
                          nutritionData["Q59."].three_month_unknown === 99) ? Values.value99 : null,

                      TwelveMonthG: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_g,
                      TwelveMonthGText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_g_txt,
                      TwelveMonthKg: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_kg,
                      TwelveMonthKgText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_kg_txt,
                      TwelveMonthOther: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_other,
                      TwelveMonthOtherText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twelve_month_other_txt,
                      TwelveMonthUnknown: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59."].twelve_month_unknown === true ||
                          nutritionData["Q59."].twelve_month_unknown === 99) ? Values.value99 : null,



                      TwentyFourMonthG: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_g,
                      TwentyFourMonthGText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_g_txt,
                      TwentyFourMonthKg: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_kg,
                      TwentyFourMonthKgText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_kg_txt,
                      TwentyFourMonthOther: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_other,
                      TwentyFourMonthOtherText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59."].twentyfour_month_other_txt,
                      TwentyFourMonthUnknown: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59."].twentyfour_month_unknown === true ||
                          nutritionData["Q59."].twentyfour_month_unknown === 99) ? Values.value99 : null,
                  },

                  Q59_1: {
                      PretransplantG: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_g,
                      PretransplantGText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_g_txt,
                      PretransplantKg: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_kg,
                      PretransplantKgText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_kg_txt,
                      PretransplantOther: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_other,
                      PretransplantOtherText: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].pretransplant_other_txt,
                      PretransplantUnknown: nutritionData["Q58."].pretransplant_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].pretransplant_unknown === true ||
                          nutritionData["Q59.1."].pretransplant_unknown === 99) ? Values.value99 : null,

                      TransplantAdmissionG: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_g,
                      TransplantAdmissionGText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_g_txt,
                      TransplantAdmissionKg: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_kg,
                      TransplantAdmissionKgText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_kg_txt,
                      TransplantAdmissionOther: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_other,
                      TransplantAdmissionOtherText: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_admission_other_txt,
                      TransplantAdmissionUnknown: nutritionData["Q58."].transplant_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].transplant_admission_unknown === true ||
                          nutritionData["Q59.1."].transplant_admission_unknown === 99) ? Values.value99 : null,


                      TransplantDischargeG: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_g,
                      TransplantDischargeGText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_g_txt,
                      TransplantDischargeKg: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_kg,
                      TransplantDischargeKgText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_kg_txt,
                      TransplantDischargeOther: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_other,
                      TransplantDischargeOtherText: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].transplant_discharge_other_txt,
                      TransplantDischargeUnknown: nutritionData["Q58."].transplant_discharge_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].transplant_discharge_unknown === true ||
                          nutritionData["Q59.1."].transplant_discharge_unknown === 99) ? Values.value99 : null,


                      ThreeMonthG: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_g,
                      threeMonthGText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_g_txt,
                      ThreeMonthKg: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_kg,
                      ThreeMonthKgText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_kg_txt,
                      ThreeMonthOther: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_other,
                      ThreeMonthOtherText: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].three_month_other_txt,
                      ThreeMonthUnknown: nutritionData["Q58."].three_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].three_month_unknown === true ||
                          nutritionData["Q59.1."].three_month_unknown === 99) ? Values.value99 : null,

                      TwelveMonthG: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_g,
                      TwelveMonthGText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_g_txt,
                      TwelveMonthKg: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_kg,
                      TwelveMonthKgText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_kg_txt,
                      TwelveMonthOther: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_other,
                      TwelveMonthOtherText: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twelve_month_other_txt,
                      TwelveMonthUnknown: nutritionData["Q58."].twelve_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].twelve_month_unknown === true ||
                          nutritionData["Q59.1."].twelve_month_unknown === 99) ? Values.value99 : null,

                      TwentyFourMonthG: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_g,
                      TwentyFourMonthGText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_g_txt,
                      TwentyFourMonthKg: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_kg,
                      TwentyFourMonthKgText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_kg_txt,
                      TwentyFourMonthOther: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_other,
                      TwentyFourMonthOtherText: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : nutritionData["Q59.1."].twentyfour_month_other_txt,
                      TwentyFourMonthUnknown: nutritionData["Q58."].twentyfour_month_diet_not_assessed === Values.value2 ? null : (nutritionData["Q59.1."].twentyfour_month_unknown === true ||
                          nutritionData["Q59.1."].twentyfour_month_unknown === 99) ? Values.value99 : null,
                  },

                  Q59_2: {
                      PretransplantG: nutritionData["Q59.2."].pretransplant_g,
                      PretransplantGText: nutritionData["Q59.2."].pretransplant_g_txt,
                      PretransplantKg: nutritionData["Q59.2."].pretransplant_kg,
                      PretransplantKgText: nutritionData["Q59.2."].pretransplant_kg_txt,
                      PretransplantOther: nutritionData["Q59.2."].pretransplant_other,
                      PretransplantOtherText: nutritionData["Q59.2."].pretransplant_other_txt,
                      PretransplantUnknown: (nutritionData["Q59.2."].pretransplant_unknown === true ||
                          nutritionData["Q59.2."].pretransplant_unknown === 99) ? Values.value99 : null,

                      TransplantAdmissionG: nutritionData["Q59.2."].transplant_admission_g,
                      TransplantAdmissionGText: nutritionData["Q59.2."].transplant_admission_g_txt,
                      TransplantAdmissionKg: nutritionData["Q59.2."].transplant_admission_kg,
                      TransplantAdmissionKgText: nutritionData["Q59.2."].transplant_admission_kg_txt,
                      TransplantAdmissionOther: nutritionData["Q59.2."].transplant_admission_other,
                      TransplantAdmissionOtherText: nutritionData["Q59.2."].transplant_admission_other_txt,
                      TransplantAdmissionUnknown: (nutritionData["Q59.2."].transplant_admission_unknown === true ||
                          nutritionData["Q59.2."].transplant_admission_unknown === 99) ? Values.value99 : null,

                      TransplantDischargeG: nutritionData["Q59.2."].transplant_discharge_g,
                      TransplantDischargeGText: nutritionData["Q59.2."].transplant_discharge_g_txt,
                      TransplantDischargeKg: nutritionData["Q59.2."].transplant_discharge_kg,
                      TransplantDischargeKgText: nutritionData["Q59.2."].transplant_discharge_kg_txt,
                      TransplantDischargeOther: nutritionData["Q59.2."].transplant_discharge_other,
                      TransplantDischargeOtherText: nutritionData["Q59.2."].transplant_discharge_other_txt,
                      TransplantDischargeUnknown: (nutritionData["Q59.2."].transplant_discharge_unknown === true ||
                          nutritionData["Q59.2."].transplant_discharge_unknown === 99) ? Values.value99 : null,


                      ThreeMonthG: nutritionData["Q59.2."].three_month_g,
                      threeMonthGText: nutritionData["Q59.2."].three_month_g_txt,
                      ThreeMonthKg: nutritionData["Q59.2."].three_month_kg,
                      ThreeMonthKgText: nutritionData["Q59.2."].three_month_kg_txt,
                      ThreeMonthOther: nutritionData["Q59.2."].three_month_other,
                      ThreeMonthOtherText: nutritionData["Q59.2."].three_month_other_txt,
                      ThreeMonthUnknown: (nutritionData["Q59.2."].three_month_unknown === true ||
                          nutritionData["Q59.2."].three_month_unknown === 99) ? Values.value99 : null,

                      TwelveMonthG: nutritionData["Q59.2."].twelve_month_g,
                      TwelveMonthGText: nutritionData["Q59.2."].twelve_month_g_txt,
                      TwelveMonthKg: nutritionData["Q59.2."].twelve_month_kg,
                      TwelveMonthKgText: nutritionData["Q59.2."].twelve_month_kg_txt,
                      TwelveMonthOther: nutritionData["Q59.2."].twelve_month_other,
                      TwelveMonthOtherText: nutritionData["Q59.2."].twelve_month_other_txt,
                      TwelveMonthUnknown: (nutritionData["Q59.2."].twelve_month_unknown === true ||
                          nutritionData["Q59.2."].twelve_month_unknown === 99) ? Values.value99 : null,

                      TwentyFourMonthG: nutritionData["Q59.2."].twentyfour_month_g,
                      TwentyFourMonthGText: nutritionData["Q59.2."].twentyfour_month_g_txt,
                      TwentyFourMonthKg: nutritionData["Q59.2."].twentyfour_month_kg,
                      TwentyFourMonthKgText: nutritionData["Q59.2."].twentyfour_month_kg_txt,
                      TwentyFourMonthOther: nutritionData["Q59.2."].twentyfour_month_other,
                      TwentyFourMonthOtherText: nutritionData["Q59.2."].twentyfour_month_other_txt,
                      TwentyFourMonthUnknown: (nutritionData["Q59.2."].twentyfour_month_unknown === true ||
                          nutritionData["Q59.2."].twentyfour_month_unknown === 99) ? Values.value99 : null,
                  },

                  Q60: {
                      PretransplantK: nutritionData["Q60."].pretransplant_k,
                      PretransplantKText: nutritionData["Q60."].pretransplant_k_txt,
                      PretransplantKc: nutritionData["Q60."].pretransplant_kc,
                      PretransplantKcText: nutritionData["Q60."].pretransplant_kc_txt,
                      PretransplantOther: nutritionData["Q60."].pretransplant_other,
                      PretransplantOtherText: nutritionData["Q60."].pretransplant_other_txt,
                      PretransplantUnknown: (nutritionData["Q60."].pretransplant_unknown === true ||
                          nutritionData["Q60."].pretransplant_unknown === 99) ? Values.value99 : null,

                      TransplantAdmissionK: nutritionData["Q60."].transplant_admission_k,
                      TransplantAdmissionKText: nutritionData["Q60."].transplant_admission_k_txt,
                      TransplantAdmissionKc: nutritionData["Q60."].transplant_admission_kc,
                      TransplantAdmissionKcText: nutritionData["Q60."].transplant_admission_kc_txt,
                      TransplantAdmissionOther: nutritionData["Q60."].transplant_admission_other,
                      TransplantAdmissionOtherText: nutritionData["Q60."].transplant_admission_other_txt,
                      TransplantAdmissionUnknown: (nutritionData["Q60."].transplant_admission_unknown === true ||
                          nutritionData["Q60."].transplant_admission_unknown === 99) ? Values.value99 : null,


                      TransplantDischargeK: nutritionData["Q60."].transplant_discharge_k,
                      TransplantDischargeKText: nutritionData["Q60."].transplant_discharge_k_txt,
                      TransplantDischargeKc: nutritionData["Q60."].transplant_discharge_kc,
                      TransplantDischargeKcText: nutritionData["Q60."].transplant_discharge_kc_txt,
                      TransplantDischargeOther: nutritionData["Q60."].transplant_discharge_other,
                      TransplantDischargeOtherText: nutritionData["Q60."].transplant_discharge_other_txt,
                      TransplantDischargeUnknown: (nutritionData["Q60."].transplant_discharge_unknown === true ||
                          nutritionData["Q60."].transplant_discharge_unknown === 99) ? Values.value99 : null,


                      ThreeMonthK: nutritionData["Q60."].three_month_k,
                      threeMonthKText: nutritionData["Q60."].three_month_k_txt,
                      ThreeMonthKc: nutritionData["Q60."].three_month_kc,
                      ThreeMonthKcText: nutritionData["Q60."].three_month_kc_txt,
                      ThreeMonthOther: nutritionData["Q60."].three_month_other,
                      ThreeMonthOtherText: nutritionData["Q60."].three_month_other_txt,
                      ThreeMonthUnknown: (nutritionData["Q60."].three_month_unknown === true ||
                          nutritionData["Q60."].three_month_unknown === 99) ? Values.value99 : null,


                      TwelveMonthK: nutritionData["Q60."].twelve_month_k,
                      TwelveMonthKText: nutritionData["Q60."].twelve_month_k_txt,
                      TwelveMonthKc: nutritionData["Q60."].twelve_month_kc,
                      TwelveMonthKcText: nutritionData["Q60."].twelve_month_kc_txt,
                      TwelveMonthOther: nutritionData["Q60."].twelve_month_other,
                      TwelveMonthOtherText: nutritionData["Q60."].twelve_month_other_txt,
                      TwelveMonthUnknown: (nutritionData["Q60."].twelve_month_unknown === true ||
                          nutritionData["Q60."].twelve_month_unknown === 99) ? Values.value99 : null,

                      TwentyFourMonthK: nutritionData["Q60."].twentyfour_month_k,
                      TwentyFourMonthKText: nutritionData["Q60."].twentyfour_month_k_txt,
                      TwentyFourMonthKc: nutritionData["Q60."].twentyfour_month_kc,
                      TwentyFourMonthKcText: nutritionData["Q60."].twentyfour_month_kc_txt,
                      TwentyFourMonthOther: nutritionData["Q60."].twentyfour_month_other,
                      TwentyFourMonthOtherText: nutritionData["Q60."].twentyfour_month_other_txt,
                      TwentyFourMonthUnknown: (nutritionData["Q60."].twentyfour_month_unknown === true ||
                          nutritionData["Q60."].twentyfour_month_unknown === 99) ? Values.value99 : null,
                  },

                  Q61: {
                      PretransplantOral: nutritionData["Q61."].pretransplant_oral,
                      PretransplantEnteral: nutritionData["Q61."].pretransplant_eternal,
                      PretransplantParental: nutritionData["Q61."].pretransplant_parental,
                      PretransplantUnknown: nutritionData["Q61."].pretransplant_routes_unknown === true ||
                          nutritionData["Q61."].pretransplant_routes_unknown === 99
                          ? Values.value99 : null,


                      TransplantOral: nutritionData["Q61."].transplant_admission_oral,
                      TransplantEnteral: nutritionData["Q61."].transplant_admission_eternal,
                      TransplantParental: nutritionData["Q61."].transplant_admission_parental,
                      TransplantUnknown: nutritionData["Q61."].transplant_admission_routes_unknown === true ||
                          nutritionData["Q61."].transplant_admission_routes_unknown === 99
                          ? Values.value99 : null,


                      TransplantDischargeOral: nutritionData["Q61."].transplant_discharge_oral,
                      TransplantDischargeEnteral: nutritionData["Q61."].transplant_discharge_eternal,
                      TransplantDischargeParental: nutritionData["Q61."].transplant_discharge_parental,
                      TransplantDischargeUnknown: nutritionData["Q61."].transplant_discharge_routes_unknown === true ||
                          nutritionData["Q61."].transplant_discharge_routes_unknown === 99
                          ? Values.value99 : null,



                      ThreeMontheOral: nutritionData["Q61."].three_month_oral,
                      ThreeMontheEnteral: nutritionData["Q61."].three_month_eternal,
                      ThreeMontheParental: nutritionData["Q61."].three_month_parental,
                      ThreeMontheUnknown: nutritionData["Q61."].three_month_routes_unknown === true ||
                          nutritionData["Q61."].three_month_routes_unknown === 99
                          ? Values.value99 : null,

                      TwelveMontheOral: nutritionData["Q61."].twelve_month_oral,
                      TwelveMontheEnteral: nutritionData["Q61."].twelve_month_eternal,
                      TwelveMontheParental: nutritionData["Q61."].twelve_month_parental,
                      TwelveMontheUnknown: nutritionData["Q61."].twelve_month_routes_unknown === true ||
                          nutritionData["Q61."].twelve_month_routes_unknown === 99
                          ? Values.value99 : null,

                      TwentyfourMontheOral: nutritionData["Q61."].twentyfour_month_oral,
                      TwentyfourMontheEnteral: nutritionData["Q61."].twentyfour_month_eternal,
                      TwentyfourMontheParental: nutritionData["Q61."].twentyfour_month_parental,
                      TwentyfourMontheUnknown: nutritionData["Q61."].twentyfour_month_routes_unknown === true ||
                          nutritionData["Q61."].twentyfour_month_routes_unknown === 99
                          ? Values.value99 : null,
                  },

                  Q61_1: [
                      {
                          RouteId: 1,
                          PreOral: nutritionData["Q61.1."]?.[1].pre_oral ?? null,
                          TransOral: nutritionData["Q61.1."]?.[1].trans_oral ?? null,
                          TransDisOral: nutritionData["Q61.1."]?.[1].trans_dis_oral ?? null,
                          ThreeOral: nutritionData["Q61.1."]?.[1].threeoral ?? null,
                          TwelveOral: nutritionData["Q61.1."]?.[1].twelve_oral ?? null,
                          TwentyFourOral: nutritionData["Q61.1."]?.[1].twentfour_oral ?? null,
                      },
                      {
                          RouteId: 2,
                          PreOral: nutritionData["Q61.1."]?.[2].pre_enteral ?? null,
                          TransOral: nutritionData["Q61.1."]?.[2].trans_enteral ?? null,
                          TransDisOral: nutritionData["Q61.1."]?.[2].trans_dis_enteral ?? null,
                          ThreeOral: nutritionData["Q61.1."]?.[2].three_enteral ?? null,
                          TwelveOral: nutritionData["Q61.1."]?.[2].twelve_enteral ?? null,
                          TwentyFourOral: nutritionData["Q61.1."]?.[2].twentfour_enteral ?? null,
                      },
                      {
                          RouteId: 3,
                          PreOral: nutritionData["Q61.1."]?.[3].pre_parental ?? null,
                          TransOral: nutritionData["Q61.1."]?.[3].trans_parental ?? null,
                          TransDisOral: nutritionData["Q61.1."]?.[3].trans_dis_parental ?? null,
                          ThreeOral: nutritionData["Q61.1."]?.[3].three_parental ?? null,
                          TwelveOral: nutritionData["Q61.1."]?.[3].twelve_parental ?? null,
                          TwentyFourOral: nutritionData["Q61.1."]?.[3].twentfour_parental ?? null,
                      }
                  ],
                  Q62: {

                      PretransplantRestriction: nutritionData["Q62."].pretransplant_yes ? Values.value1 :
                          nutritionData["Q62."].pretransplant_no ? Values.value2 : nutritionData["Q62."].pretransplant_unknown ? Values.value99 : null,
                      PretransplantRestrictionExperience: nutritionData["Q62."].pretransplant_yes_partial ? Values.value1 :
                          nutritionData["Q62."].pretransplant_yes_total ? Values.value2 : null,

                      TransplantRestriction: nutritionData["Q62."].transplant_admission_yes ? Values.value1 :
                          nutritionData["Q62."].transplant_admission_no ? Values.value2 :
                              nutritionData["Q62."].transplant_admission_unknown ? Values.value99 : null,
                      TransplantRestrictionExperience: nutritionData["Q62."].transplant_admission_partial ? Values.value1 :
                          nutritionData["Q62."].transplant_admission_total ? Values.value2 : null,


                      TransplantDischargeRestriction: nutritionData["Q62."].transplant_discharge_yes ? Values.value1 :
                          nutritionData["Q62."].transplant_discharge_no ? Values.value2 : nutritionData["Q62."].transplant_discharge_unknown ? Values.value99 : null,
                      TransplantDischargeRestrictionExperience: nutritionData["Q62."].transplant_discharge_partial ? Values.value1 :
                          nutritionData["Q62."].transplant_discharge_total ? Values.value2 : null,



                      ThreeRestriction: nutritionData["Q62."].three_month_yes ? Values.value1 :
                          nutritionData["Q62."].three_month_no ? Values.value2 : nutritionData["Q62."].three_month_unknown ? Values.value99 : null,
                      ThreeRestrictionExperience: nutritionData["Q62."].three_month_partial ? Values.value1 :
                          nutritionData["Q62."].three_month_total ? Values.value2 : null,

                      TwelveRestriction: nutritionData["Q62."].twelve_month_yes ? Values.value1 : nutritionData["Q62."].twelve_month_no ? Values.value2 :
                          nutritionData["Q62."].twelve_month_unknown ? Values.value99 : null,
                      TwelveRestrictionExperience: nutritionData["Q62."].twelve_month_partial ? Values.value1 :
                          nutritionData["Q62."].twelve_month_total ? Values.value2 : null,



                      TwentyfourRestriction: nutritionData["Q62."].twentyfour_month_yes ? Values.value1 :
                          nutritionData["Q62."].twentyfour_month_no ? Values.value2 : nutritionData["Q62."].twentyfour_month_unknown ? Values.value99 : null,
                      TwentyfourRestrictionExperience: nutritionData["Q62."].twentyfour_month_partial ? Values.value1 :
                          nutritionData["Q62."].twentyfour_month_total ? Values.value2 : null
                  },
                  Q63: nutritionData["Q63."]?.map(item => ({
                      PatientId: patientId,

                      SickId: item.sickid,
                      SickDietStart: item.startVisit,
                      SickDietStartDatePicker: item.start_dt,
                      SickDietStartDateEstimated: item.start_dt_estimated,
                      SickDietStartDateUnknown: item.startHospitalizationsUnkLTLKT,

                      SickDietEnd: item.ongoingVisit,
                      SickDietEndDatePicker: item.end_dt,
                      SickDietEndDateEstimated: item.end_dt_estimated,
                      SickDietEndDateUnknown: item.endHospitalizationsUnkLTLKT,

                      RfdMitigation: item.rfdMitigation,
                      RfdDuring: item.rfdDuring,
                      RfdAfter: item.rfdAfter,
                      RfdRenal: item.rfdRenal,
                      RfdOtherMedical: item.rfdOtherMedical,
                      RfdOtherMedicalTxt: item.rfdOtherMedical_txt,
                      RfdOtherReason: item.rfdOtherReason,
                      RfdOtherReasonTxt: item.rfdOtherReason_txt,
                      RfdUnknown: item.rfdUnknown == 99 ? 99 : 0,

                      CosDietary: item.cosDietary,
                      CosDietaryCalory: item.cosDietaryCalory,
                      CosDietaryProtien: item.cosDietaryProtien,
                      CosDietaryProtienZero: item.cosDietaryProtienZero,
                      CosDietaryCarb: item.cosDietaryCarb,
                      CosDietaryLipid: item.cosDietaryLipid,
                      CosDietaryUnknown: item.cosDietaryUnknown == 99 ? 99 : 0,

                      Modidfied: item.modidfied,
                      ModifiedNo: item.modifiedNo,
                      ModifiedParental: item.modifiedParental,
                      ModifiedEnteral: item.modifiedEnteral,
                      ModifiedUnknown: item.modifiedUnknown == 99 ? 99 : 0,

                      CosIncreased: item.cosIncreased,
                      CosMiscro: item.cosMiscro,
                      CosOther: item.cosOther,
                      CosOtherTxt: item.cosOther_Txt,
                      CosUnknown: item.cosUnknown == 99 ? 99 : 0


                  })),
                  IsValidated: validate,
                  IsAdmin: IsAdmin(),
                  PatientId: nutritionData.patientId,
                  UserId: nutritionData.userId
              };
              console.log(payload)
              const response = await NutritionService.SaveNutritionData(payload);
              ToggleLoader(false);
              if (response.status !== HTTPResponse.OK) {
                  if (response?.status === HTTPResponse.Unauthorized) {
                      HandleSessionTimeout();
                  } else throw response.error;
              } else {
                  ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                  if (response.status === HTTPResponse.OK) {

                      await getNutritionData();

                  }
                  else throw response.error;
              }
          }
            return true;
        }
        catch (error) {
            ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
        }
    };
    const [questions, setQuestions] = useState([]);
    /* <summary>
    date: 04-03-2025
    Name: MS
    description: Get Quest from DB from Q58 -Q60
    <summary>*/
    const getNutritionQuestions = async () => {
        try {
            ToggleLoader(true);
            const response = await NutritionService.GetNutritionQuestions();
            ToggleLoader(false);
            if (response.status !== HTTPResponse.OK) {
                if (response?.status === HTTPResponse.Unauthorized) {
                    HandleSessionTimeout();
                } else throw response.error;
            } else {
                if (response) {
                    const { data } = response;

                    if (data) {
                        setQuestions(data.sort((a, b) => a?.nutritionQuestionId - b?.nutritionQuestionId));
                }
            }
        }
        }
        catch (error) {
            ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
        }
    }

    const getNutritionData = async () => {
        try {
            ToggleLoader(true);
            const response = await NutritionService.GetNutritionData(patientId);

            if (response.status !== HTTPResponse.OK) {
                if (response?.status === HTTPResponse.Unauthorized) {
                    ToggleLoader(false);
                    HandleSessionTimeout();
                } else throw response.error;
            } else {
                if (response) {
                    const { data } = response;

                    if (data) {
                        const nutritionRecord58 = response.data.filter((a) => a?.questionNo === "Q58.");
                        const nutritionRecord59 = response.data.filter((a) => a?.questionNo === "Q59.");
                        const nutritionRecord59_1 = response.data.filter((a) => a?.questionNo === "Q59.1.");
                        const nutritionRecord59_2 = response.data.filter((a) => a?.questionNo === "Q59.2.");
                        const nutritionRecord60 = response.data.filter((a) => a?.questionNo === "Q60.");
                        const nutritionRecord61 = response.data.filter((a) => a?.questionNo === "Q61.");
                        const nutritionRecord62 = response.data.filter((a) => a?.questionNo === "Q62.");
                        const nutritionRecord63 = response.data.find((a) => a?.questionNo === "Q63.")?.sickDietPracticeRecords;
                        const nutritionRecord61_1 = response.data.find((a) => a?.questionNo === "Q61.1.")?.nutritionConsumptionRecords;
                  
                        setpatientLocked(response.data.find((a) => a?.questionNo === "Q63.")?.patientLocked===undefined || response.data.find((a) => a?.questionNo === "Q63.")?.patientLocked===null?false: response.data.find((a) => a?.questionNo === "Q63.")?.patientLocked);
          
                        setHideColumns((prevColumns) => {
                            const newColumns = [...prevColumns]; // Copy previous state

                            const records = nutritionRecord58[0]?.nutritionmanagementRecords?.[0] || {}; // Ensure it's defined
                            newColumns[0] = records.pretransplantDiet === Values.value2;
                            newColumns[1] = records.transplantAdmissionDiet === Values.value2;
                            newColumns[2] = records.transplantDischargeDiet === Values.value2;
                            newColumns[3] = records.threeMonthDiet === Values.value2;
                            newColumns[4] = records.twelveMonthDiet === Values.value2;
                            newColumns[5] = records.twentyfourMonthDiet === Values.value2;

                            return newColumns;
                        });
                        setNutritionData((prev) => ({
                            ...prev,
                            ["Q58."]: {
                                ...prev["Q58."], // Preserve existing Q58 data instead of using `prev`
                                pretransplant_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietDateEstimated || null,
                                pretransplant_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietDate
                                    ? DateDisplayFormat(nutritionRecord58[0].nutritionmanagementRecords[0].pretransplantDietDate)
                                    : null,
                                pretransplant_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.pretransplantDiet === Values.value99 ? true : null,
                                pretransplant_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.pretransplantDiet === Values.value2 ? true : null,
                                pretransplant_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.pretransplantDiet === Values.value1 ? true : null,


                                transplant_add_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietDateEstimated || null,
                                transplant_add_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietDate ?
                                    DateDisplayFormat(nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietDate) : null,
                                transplant_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDiet === Values.value99 ? true : null,
                                transplant_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDiet === Values.value2 ? true : null,
                                transplant_add_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDiet === Values.value1 ? true : null,


                                transplant_discharge_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietDateEstimated || null,
                                transplant_discharge_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietDate ?
                                    DateDisplayFormat(nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietDate) : null,
                                transplant_discharge_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDiet === Values.value99 ? true : null,
                                transplant_discharge_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDiet === Values.value2 ? true : null,
                                transplant_discharge_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDiet === Values.value1 ? true : null,



                                three_month_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietDateEstimated || null,
                                three_month_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietDate ?
                                    DateDisplayFormat(nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietDate) : null,
                                three_month_diet_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDiet === Values.value99 ? true : null,
                                three_month_diet_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDiet === Values.value2 ? true : null,
                                three_month_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.threeMonthDiet === Values.value1 ? true : null,


                                twelve_month_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietDateEstimated || null,
                                twelve_month_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietDate ?
                                    DateDisplayFormat(nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietDate) : null,
                                twelve_month_diet_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDiet === Values.value99 ? true : null,
                                twelve_month_diet_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDiet === Values.value2 ? true : null,
                                twelve_month_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDiet === Values.value1 ? true : null,


                                twentyfour_month_diet_date_estimated: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDietDateEstimated || null,
                                twentyfour_month_diet_date_picker: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDietDate ?
                                    DateDisplayFormat(nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDietDate) : null,
                                twentyfour_month_diet_date_unknown: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDiet === Values.value99 ? true : null,
                                twentyfour_month_diet_not_assessed: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDiet === Values.value2 ? true : null,
                                twentyfour_month_diet_date: nutritionRecord58[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthDiet === Values.value1 ? true : null,

      },
      ["Q59."]: {
        pretransplant_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantG,
        pretransplant_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantGproteinValue,
        pretransplant_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantKg,
        pretransplant_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantKgproteinValue,
        pretransplant_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantOther,
        pretransplant_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantOtherTxt,
        pretransplant_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.pretransplantUnknown,
    
        transplant_admission_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionG,
        transplant_admission_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionGproteinValue,
        transplant_admission_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKg,
        transplant_admission_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKgproteinValue,
        transplant_admission_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOther,
        transplant_admission_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOtherTxt,
        transplant_admission_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionUnknown,
    
        transplant_discharge_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeG,
        transplant_discharge_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeGproteinValue,
        transplant_discharge_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKg,
        transplant_discharge_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKgproteinValue,
        transplant_discharge_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOther,
        transplant_discharge_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOtherTxt,
        transplant_discharge_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeUnknown,
    
        three_month_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthG,
        three_month_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthGproteinValue,
        three_month_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthKg,
        three_month_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthKgproteinValue,
        three_month_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthOther,
        three_month_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthOtherTxt,
        three_month_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.threeMonthUnknown,
    
       twelve_month_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthG,
        twelve_month_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthGproteinValue,
        twelve_month_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKg,
        twelve_month_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKgproteinValue,
        twelve_month_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOther,
        twelve_month_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOtherTxt,
        twelve_month_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twelveMonthUnknown,
    
        twentyfour_month_g:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthG,
        twentyfour_month_g_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthGproteinValue,
        twentyfour_month_kg:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKg,
        twentyfour_month_kg_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKgproteinValue,
        twentyfour_month_other:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOther,
        twentyfour_month_other_txt:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOtherTxt,
        twentyfour_month_unknown:nutritionRecord59[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthUnknown,      },

        ["Q59.1."]: {
          pretransplant_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantG,
          pretransplant_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantGproteinValue,
          pretransplant_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantKg,
          pretransplant_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantKgproteinValue,
          pretransplant_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantOther,
          pretransplant_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantOtherTxt,
          pretransplant_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.pretransplantUnknown,
      
          transplant_admission_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionG,
          transplant_admission_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionGproteinValue,
          transplant_admission_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKg,
          transplant_admission_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKgproteinValue,
          transplant_admission_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOther,
          transplant_admission_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOtherTxt,
          transplant_admission_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionUnknown,
      
          transplant_discharge_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeG,
          transplant_discharge_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeGproteinValue,
          transplant_discharge_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKg,
          transplant_discharge_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKgproteinValue,
          transplant_discharge_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOther,
          transplant_discharge_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOtherTxt,
          transplant_discharge_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeUnknown,
      
          three_month_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthG,
          three_month_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthGproteinValue,
          three_month_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthKg,
          three_month_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthKgproteinValue,
          three_month_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthOther,
          three_month_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthOtherTxt,
          three_month_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.threeMonthUnknown,
      
         twelve_month_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthG,
          twelve_month_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthGproteinValue,
          twelve_month_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKg,
          twelve_month_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKgproteinValue,
          twelve_month_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOther,
          twelve_month_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOtherTxt,
          twelve_month_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twelveMonthUnknown,
      
          twentyfour_month_g:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthG,
          twentyfour_month_g_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthGproteinValue,
          twentyfour_month_kg:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKg,
          twentyfour_month_kg_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKgproteinValue,
          twentyfour_month_other:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOther,
          twentyfour_month_other_txt:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOtherTxt,
          twentyfour_month_unknown:nutritionRecord59_1[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthUnknown, 
        },

        ["Q59.2."]: {
          pretransplant_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantG,
          pretransplant_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantGproteinValue,
          pretransplant_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantKg,
          pretransplant_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantKgproteinValue,
          pretransplant_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantOther,
          pretransplant_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantOtherTxt,
          pretransplant_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.pretransplantUnknown,
      
          transplant_admission_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionG,
          transplant_admission_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionGproteinValue,
          transplant_admission_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKg,
          transplant_admission_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKgproteinValue,
          transplant_admission_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOther,
          transplant_admission_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOtherTxt,
          transplant_admission_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionUnknown,
      
          transplant_discharge_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeG,
          transplant_discharge_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeGproteinValue,
          transplant_discharge_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKg,
          transplant_discharge_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKgproteinValue,
          transplant_discharge_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOther,
          transplant_discharge_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOtherTxt,
          transplant_discharge_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeUnknown,
      
          three_month_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthG,
          three_month_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthGproteinValue,
          three_month_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthKg,
          three_month_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthKgproteinValue,
          three_month_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthOther,
          three_month_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthOtherTxt,
          three_month_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.threeMonthUnknown,
      
         twelve_month_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthG,
          twelve_month_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthGproteinValue,
          twelve_month_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKg,
          twelve_month_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKgproteinValue,
          twelve_month_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOther,
          twelve_month_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOtherTxt,
          twelve_month_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twelveMonthUnknown,
      
          twentyfour_month_g:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthG,
          twentyfour_month_g_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthGproteinValue,
          twentyfour_month_kg:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKg,
          twentyfour_month_kg_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKgproteinValue,
          twentyfour_month_other:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOther,
          twentyfour_month_other_txt:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOtherTxt,
          twentyfour_month_unknown:nutritionRecord59_2[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthUnknown, 
        },
        ["Q60."]: {
          pretransplant_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantKcal,
          pretransplant_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantKcalproteinValue,
          pretransplant_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantKgkcal,
          pretransplant_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantKgkcalValue,
          pretransplant_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantOtherkcal,
          pretransplant_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantOtherkcalTxt,
          pretransplant_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.pretransplantKcalUnknown,
      
          transplant_admission_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKcal,
          transplant_admission_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKcalValue,
          transplant_admission_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKgkcal,
          transplant_admission_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKgkcalValue,
          transplant_admission_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOtherkcal,
          transplant_admission_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOtherkcalTxt,
          transplant_admission_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionKcalUnknown,
      
          transplant_discharge_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKcal,
          transplant_discharge_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKcalValue,
          transplant_discharge_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKgkcal,
          transplant_discharge_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKgkcalValue,
          transplant_discharge_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOtherkcal,
          transplant_discharge_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOtherkcalTxt,
          transplant_discharge_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeKcalUnknown,
      
          three_month_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthKcal,
          three_month_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthGkcalValue,
          three_month_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthKgkcal,
          three_month_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthKgkcalValue,
          three_month_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthOtherkcal,
          three_month_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthOtherkcalTxt,
          three_month_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.threeMonthKcalUnknown,
      
          twelve_month_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKcal,
          twelve_month_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKcalValue,
          twelve_month_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKgkcal,
          twelve_month_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKgpkcalValue,
          twelve_month_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOtherkcal,
          twelve_month_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOtherkcalTxt,
          twelve_month_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twelveMonthKcalUnknown,
      
          twentyfour_month_k:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKcal,
          twentyfour_month_k_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKcalValue,
          twentyfour_month_kc:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKgkcal,
          twentyfour_month_kc_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKgkcalValue,
          twentyfour_month_other:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOtherkcal,
          twentyfour_month_other_txt:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthOtherkcalTxt,
          twentyfour_month_unknown:nutritionRecord60[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthKcalUnknown, 
        },

        ["Q61."]: {
          pretransplant_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.pretransplantOral,
    pretransplant_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.pretransplantEnteral,
    pretransplant_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.pretransplantParenteral,
    pretransplant_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.pretransplantRoutesUnknown,

    transplant_admission_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionOral,
    transplant_admission_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionEnteral,
    transplant_admission_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionParenteral,
    transplant_admission_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionRoutesUnknown,

    transplant_discharge_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeOral,
    transplant_discharge_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeEnteral,
    transplant_discharge_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeParenteral,
    transplant_discharge_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeRoutesUnknown,

    three_month_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.threeMonthOral,
    three_month_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.threeMonthEnteral,
    three_month_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.threeMonthParenteral,
    three_month_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.threeMonthRoutesUnknown,

    twelve_month_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twelveMonthOral,
    twelve_month_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twelveMonthEnteral,
    twelve_month_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twelveMonthParenteral,
    twelve_month_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twelveMonthRoutesUnknown,

    twentyfour_month_oral:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthMonthOral,
    twentyfour_month_eternal:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthEnteral,
    twentyfour_month_parental:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthParenteral,
    twentyfour_month_routes_unknown:nutritionRecord61[0]?.nutritionmanagementRecords?.[0]?.twentyfourMonthRoutesUnknown, 
        },

        ["Q62."]: {
          pretransplant_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietRestriction===Values.value1 ,
      pretransplant_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietRestriction===Values.value2,
      pretransplant_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietRestriction===Values.value99,
      pretransplant_yes_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietRestrictionExperience===Values.value1,
      pretransplant_yes_total:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.pretransplantDietRestrictionExperience===Values.value2,
  
      transplant_admission_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietRestriction===Values.value1 ,
      transplant_admission_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietRestriction===Values.value2,
      transplant_admission_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietRestriction===Values.value99,
      transplant_admission_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietRestrictionExperience===Values.value1 , 
      transplant_admission_total:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantAdmissionDietRestrictionExperience===Values.value2,
  
      transplant_discharge_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietRestriction===Values.value1 ,
      transplant_discharge_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietRestriction===Values.value2,
      transplant_discharge_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietRestriction===Values.value99,
      transplant_discharge_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietRestrictionExperience===Values.value1,
      transplant_discharge_total:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.transplantDischargeDietRestrictionExperience===Values.value2,
  
      three_month_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietRestriction===Values.value1 ,
      three_month_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietRestriction===Values.value2,
      three_month_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietRestriction===Values.value99,
      three_month_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietRestrictionExperience===Values.value1 ,
      three_month_total:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.threeMonthDietRestrictionExperience===Values.value2 ,
  
      twelve_month_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietRestriction===Values.value1 ,
      twelve_month_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietRestriction===Values.value2,
      twelve_month_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietRestriction===Values.value99,
      twelve_month_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietRestrictionExperirnce===Values.value1 ,
      twelve_month_total:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twelveMonthDietRestrictionExperirnce===Values.value2 ,
  
      twentyfour_month_yes:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twentyfourDietRestriction===Values.value1 ,
      twentyfour_month_no:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twentyfourDietRestriction===Values.value2,
      twentyfour_month_unknown:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twentyfourDietRestriction===Values.value99,
      twentyfour_month_partial:nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twentyfourDietRestrictionExperience===Values.value1 ,
      twentyfour_month_total: nutritionRecord62[0]?.nutritionmanagementRecords?.[0]?.twentyfourDietRestrictionExperience===Values.value2 ,
        },

        ["Q61.1."]: {
         1:{
          pre_oral:nutritionRecord61_1?.[1].preOral ?? null,
          trans_oral:nutritionRecord61_1?.[1].transOral ?? null,
          trans_dis_oral:nutritionRecord61_1?.[1].transDisOral ?? null,
          threeoral:nutritionRecord61_1?.[1].threeOral ?? null,
          twelve_oral:nutritionRecord61_1?.[1].twelveOral ?? null,
          twentfour_oral:nutritionRecord61_1?.[1].twentyFourOral ?? null,
         },
         2:{
          pre_enteral:nutritionRecord61_1?.[2].preOral ?? null,
          trans_enteral:nutritionRecord61_1?.[2].transOral ?? null,
          trans_dis_enteral:nutritionRecord61_1?.[2].transDisOral ?? null,
          three_enteral:nutritionRecord61_1?.[2].threeOral ?? null,
          twelve_enteral:nutritionRecord61_1?.[2].twelveOral ?? null,
          twentfour_enteral:nutritionRecord61_1?.[2].twentyFourOral ?? null,
         },
         3:{

          pre_parental:nutritionRecord61_1?.[3].preOral ?? null,
          trans_parental:nutritionRecord61_1?.[3].transOral ?? null,
          trans_dis_parental:nutritionRecord61_1?.[3].transDisOral ?? null,
          three_parental:nutritionRecord61_1?.[3].threeOral ?? null,
          twelve_parental:nutritionRecord61_1?.[3].twelveOral ?? null,
          twentfour_parental:nutritionRecord61_1?.[3].twentyFourOral ?? null,
         },
        },
  }));


  const errors = Array(6).fill(false); // Temporary array to store validation results
  const errors59 = Array(6).fill(null).map(() => ({
    missingValues: false,
    invalidRange: false
  }));
  const errors591 = Array(6).fill(null).map(() => ({
    missingValues: false,
    invalidRange: false
  }));
   const errors592 = Array(6).fill(null).map(() => ({
    missingValues: false,
    invalidRange: false
  }));
  const errors60 = Array(6).fill(null).map(() => ({
    missingValues: false,
    invalidRange: false
  }));
  const errors61 = Array(6).fill(false); // Temporary array to store validation results
  const errors611 = {
    1: Array(6).fill(false), 
    2: Array(6).fill(false), 
    3: Array(6).fill(false)
};   
 const errors62 = Array(6).fill(false); // Temporary array to store validation results
 let errors63 = {};


   if(nutritionRecord63){
     setSickdayDietDetails((prevState) => {
    // Create a map of existing sickId entries for quick lookup
    const existingRecordsMap = new Map(prevState?.map(item => [item.sickid, item]));

         // Set all errors to false
         sickdayDietDetails?.forEach(row => {
             const sickid = row.sickid;
             errors63[sickid] = {
                 startDateInvalid: false,
                 endDateInvalid: false,
                 cosDietaryInvalid: false,
                 rfdInvalid: false,
                 startDateInvalidRange:false
             };
         });
    // Update state based on API response
    const updatedRecords = nutritionRecord63?.map(record => {
      const existingRecord = existingRecordsMap.get(record.sickId);

      // Assign to errors63 explicitly
  errors63[record.sickId] = {
    startDateInvalid: false,
    endDateInvalid: false,
    cosDietaryInvalid: false,
    rfdInvalid: false,
    startDateInvalidRange: false
  };


      return {
        sickid: record.sickId,

        startVisit: record.sickDietStart || existingRecord?.startVisit || "",
        start_dt: record.sickDietStartDatePicker || existingRecord?.start_dt || "",
        start_dt_estimated: record.sickDietStartDateEstimated ?? existingRecord?.start_dt_estimated ?? false,
        startHospitalizationsUnkLTLKT: record.sickDietStartDateUnknown ?? existingRecord?.startHospitalizationsUnkLTLKT ?? "",

        ongoingVisit: record.sickDietEnd || existingRecord?.ongoingVisit || "",
        end_dt: record.sickDietEndDatePicker || existingRecord?.end_dt || "",
        end_dt_estimated: record.sickDietEndDateEstimated ?? existingRecord?.end_dt_estimated ?? false,
        endHospitalizationsUnkLTLKT: record.sickDietEndDateUnknown ?? existingRecord?.endHospitalizationsUnkLTLKT ?? "",


        rfdMitigation: record.rfdMitigation || existingRecord?.rfdMitigation || "",
        rfdDuring: record.rfdDuring || existingRecord?.rfdDuring || "",
        rfdAfter: record.rfdAfter || existingRecord?.rfdAfter || "",
        rfdRenal: record.rfdRenal || existingRecord?.rfdRenal || "",
        rfdOtherMedical: record.rfdOtherMedical || existingRecord?.rfdOtherMedical || "",
        rfdOtherMedical_txt: record.rfdOtherMedicalTxt || existingRecord?.rfdOtherMedical_txt || "",
        rfdOtherReason: record.rfdOtherReason || existingRecord?.rfdOtherReason || "",
        rfdOtherReason_txt: record.rfdOtherReasonTxt || existingRecord?.rfdOtherReason_txt || "",
        rfdUnknown: record.rfdUnknown || existingRecord?.rfdUnknown || "",
        
  
  
        cosDietary: record.cosDietary || existingRecord?.cosDietary || "",
        cosDietaryCalory: record.cosDietaryCalory || existingRecord?.cosDietaryCalory || "",
        cosDietaryProtien: record.cosDietaryProtien || existingRecord?.cosDietaryProtien || "",
        cosDietaryProtienZero: record.cosDietaryProtienZero || existingRecord?.cosDietaryProtienZero || "",
        cosDietaryCarb: record.cosDietaryCarb || existingRecord?.cosDietaryCarb || "",
        cosDietaryLipid: record.cosDietaryLipid || existingRecord?.cosDietaryLipid || "",
        cosDietaryUnknown: record.cosDietaryUnknown || existingRecord?.cosDietaryUnknown || "",
  
        modidfied:record.modidfied || existingRecord?.modidfied || "",
        modifiedNo:record.modifiedNo || existingRecord?.modifiedNo || "",
        modifiedParental:record.modifiedParental || existingRecord?.modifiedParental || "",
        modifiedEnteral:record.modifiedEnteral || existingRecord?.modifiedEnteral || "",
        modifiedUnknown:record.modifiedUnknown || existingRecord?.modifiedUnknown || "",
  
        cosIncreased:record.cosIncreased || existingRecord?.cosIncreased || "",
        cosMiscro:record.cosMiscro || existingRecord?.cosMiscro || "",
        cosOther:record.cosOther || existingRecord?.cosOther || "",
        cosOther_Txt:record.cosOtherTxt || existingRecord?.cosOther_Txt || "",
        cosUnknown:record.cosUnknown || existingRecord?.cosUnknown || "",
       
      };
      
    });

    return updatedRecords;
  });
   }
 
   setNutritionError(prevState => ({
    ...prevState,
    "Q58.": errors,
    "Q59.":errors59,
    "Q59.1.":errors591,
    "Q59.2.":errors592,
    "Q60.":errors60,
    "Q61.":errors61,
   "Q61.1.":errors611,
    "Q62.":errors62,
    "Q63.":{ 
      ...(prevState["Q63."] || {}), // Preserve existing errors
      ...errors63 // Update errors for current sickIds
  }}));
        }
      }
      ToggleLoader(false);
    }
    }
     catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
      }
const dates=GetLocalStorageData("ClinicalCharacteristicsDates");
  
  
useEffect(()=>{
  getNutritionQuestions();
  getNutritionData();
},[]);

const handleCheckboxChange = (questionNumber, e,colIndex,index,isFromTextChange = false) => {
  let divIndex;
  if(questionNumber ==="Q58."){
divIndex=2
  }
 else if(questionNumber !=="Q61."){
    if(index===0){
  divIndex=0
}
else if(index===1){
  divIndex=2
}
else{
  divIndex=4
}
  }

  const selectedField =questionNumber==="Q61."?fieldMapping[questionNumber][colIndex][index]:
  questionNumber==="Q58."? fieldMapping[questionNumber][colIndex][divIndex-1]:
  fieldMapping[questionNumber][colIndex][divIndex];

        setNutritionData((prev) => ({
            ...prev,
            [questionNumber]: {
                ...prev[questionNumber],
                [selectedField]: e.target.checked, // Set your desired value
            },
        }));
        if (!e?.target.checked && !isFromTextChange && questionNumber !== "Q61.") {
            handleTextChange(questionNumber, { target: { value: null } }, colIndex, index, true);
        }
        if (questionNumber === "Q61.") {
            const selectedField = fieldMapping[questionNumber]?.[colIndex]?.[fieldMapping[questionNumber]?.[colIndex]?.length - 1];
            setNutritionData((prev) => ({
                ...prev,
                [questionNumber]: {
                    ...prev[questionNumber],
                    [selectedField]: null, // Set your desired value
                },
            }));
        }
       
        if (!e?.target.checked && !isFromTextChange && questionNumber !== "Q61.") {
            handleTextChange(questionNumber, { target: { value: null } }, colIndex, index, true);
        }


if (questionNumber === "Q61." && !e.target.checked) {
  const objectNumber = index + 1; // Get the correct object number (1-based index)

  const fieldName = fieldMapping["Q61.1."]?.[index + 1]?.[colIndex]; // Get correct field name

            if (fieldName && objectNumber) { // Ensure field exists
                setNutritionData((prev) => ({
                    ...prev,
                    ["Q61.1."]: {
                        ...prev["Q61.1."],
                        [objectNumber]: {
                            ...prev["Q61.1."][objectNumber],
                            [fieldName]: null, // Set the corresponding field to null
                        },
                    },
                }));
            }
        }
        if(questionNumber !=="Q58." && questionNumber !=="Q61." && questionNumber !=="Q61.1." && questionNumber !=="Q62."){
          const selectedField = fieldMapping[questionNumber][colIndex][divIndex];
          const allFields = fieldMapping[questionNumber][colIndex] || [];
          let fieldsToNullify;
          fieldsToNullify = allFields.filter((field, i) => i === 6 && field !== selectedField)
          
          setNutritionData((prev) => ({
            ...prev,
            [questionNumber]: {
                ...prev[questionNumber],
                ...Object.fromEntries(fieldsToNullify?.map(field => [field, null])),
            },
        }));
        }

        if(questionNumber ==="Q58." && e.target.checked){
          const selectedField = fieldMapping[questionNumber][colIndex][divIndex];
          const allFields = fieldMapping[questionNumber][colIndex] || [];
          const fieldsToUpdate = {
            [allFields[0]]: true,
            [allFields[3]]: null,
            [allFields[4]]: null,
        };
    
        setNutritionData((prev) => ({
            ...prev,
            [questionNumber]: {
                ...prev[questionNumber],
                ...fieldsToUpdate,
            },
        }));

        if (questionNumber === "Q58.") {
          setHideColumns((prevColumns) => {
              const newColumns = [...prevColumns]; // Copy previous state
              newColumns[colIndex] = index === Values.value4; // Hide only if index is 4
              return newColumns;
          });
          setNutritionError((prev)=>({
            ...prev,
            [questionNumber]:{
              ...(prev[questionNumber] || {}), 
              [colIndex]:false
            }
          })) 
      }
        }
        setNutritionError((prev)=>({
          ...prev,
          [questionNumber]:{
            ...(prev[questionNumber] || {}), 
            [colIndex]:false
          }
        }))
    };
    const handleRadioChange = (questionNumber, e, colIndex, index) => {
        let divIndex;
        if (questionNumber === "Q58." || questionNumber === "Q62.") {
            divIndex = index
        }
        else {
            divIndex = fieldMapping[questionNumber]?.[colIndex].length - 1;
        }

        
        const selectedField = fieldMapping[questionNumber][colIndex][divIndex];
        const allFields = fieldMapping[questionNumber][colIndex] || [];
        let fieldsToNullify;
        if (questionNumber === "Q62.") {
            fieldsToNullify = allFields?.filter((field, i) => i !== index);

          //   if (divIndex === 3 || divIndex === 4) {
          //     fieldsToNullify = fieldsToNullify.filter((field, i) => {
          //         const actualIndex = allFields.indexOf(field);
          //         return actualIndex !== 0;
          //     });
          // }
          let nullifiedFields = Object.fromEntries(fieldsToNullify?.map((field, i) => {
            if ((divIndex === 3 || divIndex === 4) && i === 0) {
              return [field, true];
            } else {
              return [field, null];
            }
          }));
            setNutritionData((prev) => ({
              ...prev,
              [questionNumber]: {
                  ...prev[questionNumber],
                  [selectedField]: e.target.value === "on", // Set your desired value
                  //...Object.fromEntries(fieldsToNullify?.map(field => [field, null])),
                  ...nullifiedFields,
              },
          }));
        }
        else if(questionNumber==="Q58." && index===Values.value4){
          const questionsToNullify = ["Q59."
            , "Q59.1.", "Q59.2.", "Q60.","Q61.","Q62."
          ];

        fieldsToNullify = allFields.filter(field => field !== selectedField);
        setNutritionData((prev) => {
          let updatedData = { ...prev };

          questionsToNullify.forEach((q) => {
              if (fieldMapping[q] && Array.isArray(fieldMapping[q][colIndex])) {
                  updatedData[q] = {
                      ...updatedData[q],
                      ...Object.fromEntries(fieldMapping[q][colIndex].map(field => [field, null]))
                  };
              }
          });

          // Preserve Q58.'s selected value
          updatedData["Q58."] = {
            ...prev["Q58."],
            [selectedField]: e.target.value === "on", // Preserve selected value
            ...Object.fromEntries(fieldsToNullify.map(field => [field, null])) // Nullify other fields in Q58
        };


       
          return updatedData;
      });
      setNutritionError((prev) => {
        let updatedError = { ...prev };

        questionsToNullify.forEach((q) => {
            updatedError[q] = {
                ...(prev[q] || {}),
                [colIndex]: false
            };
        });

        return updatedError;
    });
        }
        else {
            fieldsToNullify = index === 0
                ? allFields.filter((field, i) => i !== 2 && i !== 1 && field !== selectedField)
                : allFields.filter(field => field !== selectedField);
                if (questionNumber === "Q61.") {
                  setNutritionData((prev) => {
                      let updatedData = {
                          ...prev,
                          [questionNumber]: {
                              ...prev[questionNumber],
                              [selectedField]: e.target.value === "on", // Set your desired value
                              ...Object.fromEntries(fieldsToNullify?.map(field => [field, null])),
                          },
                          ["Q61.1."]: { ...prev["Q61.1."] } // Ensure Q61.1. exists
                      };

                      // Iterate over all routeIds in Q61.1.
                      Object.keys(fieldMappingtwo["Q61.1."] || {}).forEach(routeId => {
                          // Get field name based on colIndex
                          const fieldName = fieldMappingtwo["Q61.1."][routeId]?.[colIndex];
              
                          if (fieldName) {
                              updatedData["Q61.1."] = {
                                  ...updatedData["Q61.1."],
                                  [routeId]: {
                                      ...(updatedData["Q61.1."]?.[routeId] || {}), // Ensure routeId object exists
                                      [fieldName]: null // Set only the correct field to null
                                  }
                              };
                          }
                      });
              
                      return updatedData;
                  });
                  setNutritionError((prev) => {
                    let updatedErrors = { ...prev };
            
                    // Iterate over all routeIds in Q61.1.
                    Object.keys(fieldMappingtwo["Q61.1."] || {}).forEach(routeId => {
                        // Get field name based on colIndex
                        const fieldName = fieldMappingtwo["Q61.1."][routeId]?.[colIndex];
            
                        if (fieldName) {
                            updatedErrors["Q61.1."] = {
                                ...updatedErrors["Q61.1."] || {}, // Ensure Q61.1. exists
                                [routeId]: {
                                    ...(updatedErrors["Q61.1."]?.[routeId] || {}), // Ensure routeId exists
                                    [fieldName]: false, // Set error to false
                                    [colIndex]: false, // Set the corresponding index to false
                                }
                            };
                        }
                    });
            
                    return updatedErrors;
                });
              } 
                else{
                   setNutritionData((prev) => ({
                  ...prev,
                  [questionNumber]: {
                      ...prev[questionNumber],
                      [selectedField]: e.target.value === "on", // Set your desired value
                      ...Object.fromEntries(fieldsToNullify?.map(field => [field, null])),
                  },
              }));
                }
               
        }

       
        if (questionNumber === "Q58.") {
            setHideColumns((prevColumns) => {
                const newColumns = [...prevColumns]; // Copy previous state
                newColumns[colIndex] = index === Values.value4; // Hide only if index is 4
                return newColumns;
            });
            setNutritionError((prev)=>({
              ...prev,
              [questionNumber]:{
                ...(prev[questionNumber] || {}), 
                [colIndex]:false
              }
            }));

            
        }
        if(questionNumber !=="Q58."){
         setNutritionError((prev)=>({
          ...prev,
          [questionNumber]:{
            ...(prev[questionNumber] || {}), 
            [colIndex]:false
          }
        })) 
        }
        if (index === Values.value4) {
        setNutritionData((prev) => {
            const updatedData = { ...prev };

            // Set selected Q58 field
            updatedData["Q58."] = {
                ...prev["Q58."],
                [selectedField]: e.target.value === "on",
                ...Object.fromEntries(fieldsToNullify.map(field => [field, null]))
            };

            // Set corresponding Q61.1. fields to null at colIndex for each routeId
            Object.entries(fieldMappingtwo["Q61.1."] || {}).forEach(([routeId, fieldArray]) => {
                const fieldName = fieldArray[colIndex];
                if (fieldName) {
                    updatedData["Q61.1."] = {
                        ...(updatedData["Q61.1."] || {}),
                        [routeId]: {
                            ...(updatedData["Q61.1."]?.[routeId] || {}),
                            [fieldName]: null
                        }
                    };
                }
            });

            return updatedData;
        });
      }
    };

const handleRadioChangeRoutes = (e,questionNumber,routeId,value,field) => {
setNutritionData(prevState => ({
  ...prevState,
  [questionNumber]: {
      ...prevState[questionNumber],
      [routeId]: {
          ...(prevState[questionNumber]?.[routeId] || {}), // Ensure the routeId object exists
          [field]: value
      }
  }
}));

 const fieldIndex = fieldMappingtwo[questionNumber]?.[routeId]?.indexOf(field);

    if (fieldIndex !== -1) { // Ensure the field exists in mapping
        setNutritionError((prev) => ({
            ...prev,
            [questionNumber]: {
                ...(prev[questionNumber] || {}), // Ensure questionNumber object exists
                [routeId]: {
                    ...(prev[questionNumber]?.[routeId] || {}), // Ensure routeId object exists
                    [fieldIndex]: false // Set error to false only for the correct index
                }
            }
        }));
    }
};

    const handleTextChange = (questionNumber, e, colIndex, index, isFromFn) => {
        const newValue = e.target.value;

        if (!isFromFn && (questionNumber === 'Q59.' || questionNumber === 'Q59.1.' || questionNumber === 'Q59.1.1' || questionNumber === 'Q59.2.') && index !== 2) {
            if (!AllowNumberWithTwoDecimal(newValue)) return;

 
  }
 
  if(questionNumber==='Q60.' && index !==2){
    if (!AllowNumberWithTwoDecimal(newValue)) return;

 }


  let divIndex;
  if(index===0){
    divIndex=1
  }
  else if(index===1){
   
    divIndex=3
  }
  else{
    divIndex=5
  }
  const selectedField = fieldMapping[questionNumber][colIndex][divIndex];

        setNutritionData((prev) => ({
            ...prev,
            [questionNumber]: {
                ...prev[questionNumber],
                [selectedField]: newValue, // Set your desired value
            },
        }));
        if (newValue !== null) {
            handleCheckboxChange(questionNumber, { target: { checked: true } }, colIndex, index, true);
        }
    };

    const handleDateChange = (colIndex, date, questionNumber) => {
        const selectedField = fieldMapping[questionNumber][colIndex]?.[2];
        const firstRadio = fieldMapping[questionNumber][colIndex]?.[0];
        
        const allFields = fieldMapping[questionNumber][colIndex] || [];

        const fieldsToNullify = allFields.filter((field, i) => i !== 0 && i !== 2 && i !== 1 && field !== selectedField)
       
        setNutritionData((prev) => ({
            ...prev,
            [questionNumber]: {
                ...prev[questionNumber],
                [selectedField]: date, // Set your desired value
                [firstRadio]: true,
                ...Object.fromEntries(fieldsToNullify?.map(field => [field, null])),
            },
        }));
        setHideColumns((prevColumns) => {
            const newColumns = [...prevColumns]; // Copy previous state
            newColumns[colIndex] = false; // Hide only if index is 4
            return newColumns;
        });
        if(questionNumber==="Q58."){
          setNutritionError((prev)=>({
                  ...prev,
                  [questionNumber]:{
                    // ...prev.questionNumber,
                    ...(prev[questionNumber] || {}), 
                    [colIndex]:false
                  }
                })) 
        }
        
    };

const HandleFieldChange = (e,sickid) => {
  const { name, value, type, checked } = e.target;
  const splitNameArray = name.split("-");
  const fieldName = splitNameArray[0];
  const index = parseInt(splitNameArray[1], 10);

  setSickdayDietDetails((prevDetails) => {
    let updatedDetails = prevDetails?.map((item, idx) => {
      if (idx === index) {
        let updatedItem = {
          ...item,
          [fieldName]: type === "checkbox" ? checked : (type === "radio" && fieldName !== "rvUnknown" ? parseInt(value, 10) || 0 : value),
        };
        if (fieldName === "startVisit" && parseInt(value, 10) === Values.value1) {
          updatedItem.start_dt = "";
          updatedItem.start_dt_estimated = false;
          updatedItem.startHospitalizationsUnkLTLKT = "";

          updatedItem.ongoingVisit = "";
          updatedItem.end_dt = "";
          updatedItem.end_dt_estimated = false;
          updatedItem.endHospitalizationsUnkLTLKT = "";
          updatedItem.endDateInvalid = false;

          updatedItem.soc = "";

          updatedItem.rvMMA = false;
          updatedItem.rvRenal = false;
          updatedItem.rvOther = false;
          updatedItem.rvOtherTxt = "";

          updatedItem.startDateInvalid = false;
          updatedItem.endDateEmptyError = false;

          updatedItem.q29StartVisitEmpty = false;

          updatedItem.q29EndVisitEmpty = false;
          updatedItem.q29SOCEmpty = false;
          updatedItem.q29ReasonVisitEmpty = false;

          updatedItem.startDateEmptyError = false;
          updatedItem.rvOtherEmptyError = false;

          updatedItem.endDateInvalid = false;
          updatedItem.q29StartDateUnkEmpty = false;


                        updatedItem.rfdMitigation= false;
                        updatedItem.rfdDuring= false;
                        updatedItem.rfdAfter= false;
                        updatedItem.rfdRenal= false;
                        updatedItem.rfdOtherMedical= false;
                        updatedItem.rfdOtherMedical_txt= null;
                        updatedItem.rfdOtherReason= false;
                        updatedItem.rfdOtherReason_txt= null;
                        updatedItem.rfdUnknown= false;
            
            
            
                        updatedItem.cosDietary= false;
                        updatedItem.cosDietaryCalory= false;
                        updatedItem.cosDietaryProtien= false;
                        updatedItem.cosDietaryProtienZero= false;
                        updatedItem.cosDietaryCarb= false;
                        updatedItem.cosDietaryLipid= false;
                        updatedItem.cosDietaryUnknown= false;
            
                        updatedItem.modidfied= false;
                        updatedItem.modifiedNo= false;
                        updatedItem.modifiedParental= false;
                        updatedItem.modifiedEnteral= false;
                        updatedItem.modifiedUnknown= false;
            
                        updatedItem.cosIncreased= false;
                        updatedItem.cosMiscro= false;
                        updatedItem.cosOther= false;
                        updatedItem.cosOther_Txt= "";
                        updatedItem.cosUnknown= false;
            
                        updatedItem.startDateInvalid= false;

                    } else if (fieldName === "startVisit" && parseInt(value, 10) === Values.value2) {
                        updatedItem.start_dt = "";
                        updatedItem.start_dt_estimated = false;
                        updatedItem.startHospitalizationsUnkLTLKT = "";
                        updatedItem.startDateInvalid = false;
                        updatedItem.q29StartDateUnkEmpty = false;

          updatedItem.q29StartVisitEmpty = false;
          updatedItem.endDateInvalid = false;
        } else if (fieldName === "startVisit" && parseInt(value, 10) === Values.value99) {
          updatedItem.start_dt = "";
          updatedItem.start_dt_estimated = false;
          updatedItem.startHospitalizationsUnkLTLKT = "";
          updatedItem.startDateInvalid = false;

          updatedItem.q29StartVisitEmpty = false;
          updatedItem.endDateInvalid = false;
        } else if (fieldName === "startHospitalizationsUnkLTLKT") {
          updatedItem.startHospitalizationsUnkLTLKT = parseInt(value, 10);
          updatedItem.start_dt = "";
          updatedItem.start_dt_estimated = false;
          updatedItem.startVisit = 99;
          updatedItem.q29StartDateUnkEmpty = false;

          updatedItem.q29StartVisitEmpty = false;
          updatedItem.startDateInvalid = false;
          updatedItem.endDateInvalid = false;
        } else if (fieldName === "start_dt_estimated") {
          updatedItem.startVisit = 2;
          updatedItem.startHospitalizationsUnkLTLKT = "";
          updatedItem.q29StartVisitEmpty = false;
          updatedItem.q29StartDateUnkEmpty = false;
        }


        if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value1) {
          updatedItem.end_dt = "";
          updatedItem.end_dt_estimated = false;
          updatedItem.endHospitalizationsUnkLTLKT = "";
          updatedItem.q29EndDateUnkEmpty = false;

          updatedItem.q29EndVisitEmpty = false;
          updatedItem.endDateInvalid = false;
        } else if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value2) {
          updatedItem.end_dt = "";
          updatedItem.end_dt_estimated = false;
          updatedItem.endHospitalizationsUnkLTLKT = "";
          updatedItem.q29EndVisitEmpty = false;
          updatedItem.endDateInvalid = false;
          updatedItem.q29EndDateUnkEmpty = false;
        } else if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value99) {
          updatedItem.end_dt = "";
          updatedItem.end_dt_estimated = false;
          updatedItem.endHospitalizationsUnkLTLKT = "";
          updatedItem.q29EndVisitEmpty = false;
          updatedItem.endDateInvalid = false;
        } else if (fieldName === "endHospitalizationsUnkLTLKT") {
          updatedItem.end_dt = "";
          updatedItem.end_dt_estimated = false;
          updatedItem.ongoingVisit = 99;
          updatedItem.q29EndVisitEmpty = false;
          updatedItem.endDateInvalid = false;
          updatedItem.q29EndDateUnkEmpty = false;
        }

        if (fieldName === "end_dt_estimated") {
          updatedItem.ongoingVisit = 2;
          updatedItem.endHospitalizationsUnkLTLKT = "";
          updatedItem.q29EndVisitEmpty = false;
          updatedItem.q29EndDateUnkEmpty = false;
        }

        if (fieldName === "rvOtherMMA" && !checked) {
          updatedItem.rvMMAOtherTxt = "";
          updatedItem.q29ReasonVisitEmpty = false;
        }

        if (fieldName === "rvOther" && !checked) {
          updatedItem.rvOtherTxt = "";
          updatedItem.q29ReasonVisitEmpty = false;
        }

        if (fieldName === "rvOtherTxt") {
          updatedItem.rvOther = value.trim() !== "";
          updatedItem.rvUnknown = false;
          updatedItem.rvOtherEmptyError = false;
          updatedItem.q29ReasonVisitEmpty = false;
        }

        
        if (["rvMMA", "rvRenal", "rvOther"].includes(fieldName)) {
          updatedItem.rvUnknown = false;
          updatedItem.q29ReasonVisitEmpty = false;
        }

        if (fieldName === "soc") {
          updatedItem.q29SOCEmpty = false;
        }

        if (fieldName === "rvUnknown" && checked) {
          updatedItem.rvMMA = false;
          updatedItem.rvRenal = false;
          updatedItem.rvOther = false;
          updatedItem.rvOtherTxt = "";
          updatedItem.q29ReasonVisitEmpty = false;
          updatedItem.rvUnknown = checked ;
        }

        return updatedItem;
      }
      return item;
    });

    if (fieldName === "startVisit" && parseInt(value, 10) === Values.value1 && updatedDetails.length > 1) {
      updatedDetails = [updatedDetails[0]]; // Keep only the first entry
    }

    return updatedDetails;
  });
  
  if (sickid >=0 && ["startVisit", "startHospitalizationsUnkLTLKT", "start_dt_estimated"].includes(fieldName)) {
    setNutritionError((prev) => ({
      ...prev,
      ["Q63."]: {
        ...(prev["Q63."] || {}), // Preserve other question data in Q63.
        [sickid]: {
          ...(prev["Q63."]?.[sickid] || {}), // Preserve existing sickid data
          startDateInvalid: false, // Set startDateInvalid to false for the given sickid
          startDateInvalidRange:false,
        },
      },
    }));
  }

  else if (sickid >=0 && ["ongoingVisit", "end_dt_estimated", "endHospitalizationsUnkLTLKT"].includes(fieldName)) {
    setNutritionError((prev) => ({
      ...prev,
      ["Q63."]: {
        ...(prev["Q63."] || {}), // Preserve other question data in Q63.
        [sickid]: {
          ...(prev["Q63."]?.[sickid] || {}), // Preserve existing sickid data
          endDateInvalid: false, // Set startDateInvalid to false for the given sickid
        },
      },
    }));
  }

};

function deleteHospitalizationVisitDetails(id) {
  const newHospitalizationVisitDetailsArray = [...sickdayDietDetails];
  newHospitalizationVisitDetailsArray.splice(id, 1);
  setSickdayDietDetails(newHospitalizationVisitDetailsArray);
}
function addSickdayDietRow(e) {
  setSickdayDietDetails((prev) => [
    ...prev,
    {
      sickid: prev.length+1,

      startVisit: "",
      start_dt: "",
      start_dt_estimated: false,
      startHospitalizationsUnkLTLKT: "",

      ongoingVisit: "",
      end_dt: "",
      end_dt_estimated: false,
      endHospitalizationsUnkLTLKT: "",

      rfdMitigation:false,
      rfdDuring:false,
      rfdAfter:false,
      rfdRenal:false,
      rfdOtherMedical:false,
      rfdOtherMedical_txt:null,
      rfdOtherReason:false,
      rfdOtherReason_txt:null,
      rfdUnknown:false,
      


      cosDietary: false,
      cosDietaryCalory: false,
      cosDietaryProtien: false,
      cosDietaryProtienZero: false,
      cosDietaryCarb: false,
      cosDietaryLipid: false,
      cosDietaryUnknown: false,

      modidfied:false,
      modifiedNo:false,
      modifiedParental:false,
      modifiedEnteral:false,
      modifiedUnknown:false,

      cosIncreased:false,
      cosMiscro:false,
      cosOther:false,
      cosOther_Txt:"",
      cosUnknown:false,
    },
  ]);
}
const handleCheckboxChangeSickDay = (e,field,sickid) => {
 
  setSickdayDietDetails((prev) =>
    prev?.map((item) => {
      if (item.sickid === sickid) {
        let updatedItem = { ...item, [field]: e.target.checked };
        setNutritionError((prevErrors) => {
          const prevErrorState = prevErrors["Q63."]?.[sickid] || {};
          
        if (field === "rfdOtherMedical" && !e.target.checked) {
         
          updatedItem.rfdOtherMedical_txt = "";
        }
        
        if (field === "rfdOtherReason" && !e.target.checked) {
          
          updatedItem.rfdOtherReason_txt = "";
        }
        if ((field === "rfdOtherReason_txt" || 
          field === "rfdOtherReason" ||
          field === "rfdOtherMedical_txt" ||
          field === "rfdOtherMedical" ||
          field === "rfdRenal" ||
          field === "rfdAfter" ||
          field === "rfdDuring" ||
          field === "rfdMitigation"

        ) && e.target.checked) {
          prevErrorState.rfdInvalid = false;
          updatedItem.rfdUnknown = false;
        }
        if (field === "cosOther" && !e.target.checked) {
         
          updatedItem.cosOther_Txt = "";
        }
        if ((field === "cosDietary" ||field === "cosIncreased" ||field === "cosMiscro" ||
          field === "cosOther"  )&& e.target.checked) {
            prevErrorState.cosDietaryInvalid = false;
          updatedItem.cosUnknown = false;
        }
        if ((field === "cosDietaryCalory" ||field === "cosDietaryProtien" ||  
          field === "cosDietaryProtienZero" ||field === "cosDietaryCarb" ||field === "cosDietaryLipid" 
        )&& e.target.checked) {
         
          updatedItem.cosDietary = true;
          updatedItem.cosUnknown = false;
          updatedItem.cosDietaryUnknown= false;
          prevErrorState.cosDietaryInvalid = false;
        }
        
        if ((field === "modifiedNo" ||field === "modifiedParental" ||  
          field === "modifiedEnteral"   )&& e.target.checked) {
         
          updatedItem.modidfied = true;
          updatedItem.modifiedUnknown = "";
          updatedItem.cosUnknown= false;
          prevErrorState.cosDietaryInvalid=false
        }
        if (field === "cosDietaryProtien" && !e.target.checked) {
         
          updatedItem.cosDietaryProtienZero= "";
        }
        if (field === "cosDietaryProtienZero" && e.target.checked) {
         
          updatedItem.cosDietaryProtien= true;
          prevErrorState.cosDietaryInvalid=false
        }
        if (field === "cosDietary" && !e.target.checked) {
          updatedItem.cosDietary= "";
          updatedItem.cosDietaryCalory= "";
          updatedItem.cosDietaryProtien= "";
          updatedItem.cosDietaryProtien= "";
          updatedItem.cosDietaryProtienZero= "";
          updatedItem.cosDietaryCarb= "";
          updatedItem.cosDietaryLipid= "";

        }
        if (field === "modidfied" && !e.target.checked) {
            updatedItem.modifiedEnteral = false;
            updatedItem.modifiedNo = false;
            updatedItem.modifiedParental = false;
            updatedItem.modifiedUnknown = "";

        }
        if (field === "modidfied" && e.target.checked) {
            updatedItem.modidfied = true;
            prevErrorState.cosDietaryInvalid=false
          
        }
        return {
          ...prevErrors,
          ["Q63."]: {
            ...prevErrors["Q63."],
            [sickid]: { 
              ...prevErrorState
            },
          },
        };
      });

         return updatedItem;
                }
                return item;
            })
        );

    };
    const handleTextChangeSickDay = (e, field, sickid) => {


  setSickdayDietDetails((prev) =>
    prev?.map((item) => {
      if (item.sickid === sickid) {
        let updatedItem = { ...item, [field]: e.target.value} ;
        setNutritionError((prevErrors) => {
          const prevErrorState = prevErrors["Q63."]?.[sickid] || {};

          
        if (field === "rfdOtherMedical_txt" && e.target.value.trim() !== "") {
         
          updatedItem.rfdOtherMedical = true;
          prevErrorState.rfdInvalid = false;
        }
        if (field === "rfdOtherReason_txt" && e.target.value.trim() !== "") {
          
          updatedItem.rfdOtherReason = true;
          prevErrorState.rfdInvalid = false;
        }
        if (field === "cosOther_Txt" && e.target.value.trim() !== "") {
          
          updatedItem.cosOther = true;
          updatedItem.cosUnknown = false;
          prevErrorState.cosDietaryInvalid = false;

        }
        if ((field === "rfdOtherMedical_txt" ||field === "rfdOtherReason_txt") && e.target.value.trim() !== "") {
          updatedItem.rfdUnknown = "";
          prevErrorState.rfdInvalid=false
        }
        return {
          ...prevErrors,
          ["Q63."]: {
            ...prevErrors["Q63."],
            [sickid]: {
              ...prevErrorState
            },
          },
        };
      });
        return updatedItem;
      }
      return item;
    })
  );
};

const handleRadioChangeSickDay = (e, field, sickid) => {
  const isChecked = e.target.checked;

  setSickdayDietDetails((prev) =>
    prev.map((item) => {
      if (item.sickid !== sickid) return item;

      let updatedItem = { ...item, [field]: isChecked ? 99 : null };

      // Apply specific resets when certain checkboxes are checked/unchecked
      if (field === "cosDietaryUnknown" && isChecked) {
        updatedItem = {
          ...updatedItem,
          cosDietary: true,
          cosDietaryCalory: "",
          cosDietaryCarb: "",
          cosDietaryLipid: "",
          cosDietaryProtien: "",
          cosDietaryProtienZero: "",
        };
      }

      if (field === "rfdUnknown" && isChecked) {
        updatedItem = {
          ...updatedItem,
          rfdMitigation: "",
          rfdDuring: "",
          rfdAfter: "",
          rfdOtherMedical: "",
          rfdOtherMedical_txt: "",
          rfdOtherReason_txt: "",
          rfdOtherReason: "",
          rfdRenal: "",
        };
      }

      if (field === "modifiedUnknown" && isChecked) {
        updatedItem = {
          ...updatedItem,
          modidfied: true,
          modifiedNo: "",
          modifiedParental: "",
          modifiedEnteral: "",
        };
      }

      if (field === "cosOther" && !isChecked) {
        updatedItem = {
          ...updatedItem,
          cosOther_Txt: "",
        };
      }

      if (field === "cosUnknown" && isChecked) {
        updatedItem = {
          ...updatedItem,
          cosDietaryCalory: "",
          cosDietaryCarb: "",
          cosDietaryLipid: "",
          cosDietaryProtien: "",
          cosDietaryProtienZero: "",
          cosOther_Txt: "",
          modifiedNo: "",
          modifiedParental: "",
          modifiedEnteral: "",
          cosDietary: "",
          cosMiscro: "",
          cosIncreased: "",
          cosOther: "",
          modidfied: "",
          cosDietaryUnknown: "",
          modifiedUnknown: "",
        };
      }

      return updatedItem;
    })
  );

  // Handle error state separately
  setNutritionError((prevErrors) => {
    const prevErrorState = prevErrors["Q63."]?.[sickid] || {};

    if (field === "cosDietaryUnknown" && isChecked) {
      prevErrorState.cosDietaryInvalid = false;
    }
    if (field === "rfdUnknown" && isChecked) {
      prevErrorState.rdf = false;
    }
    if (field === "modifiedUnknown" && isChecked) {
      prevErrorState.cosDietaryInvalid = false;
    }
    if (field === "cosOther" && !isChecked) {
      prevErrorState.cosDietaryInvalid = false;
    }
    if (field === "cosUnknown" && isChecked) {
      prevErrorState.cosDietaryInvalid = false;
    }

    return {
      ...prevErrors,
      ["Q63."]: {
        ...prevErrors["Q63."],
        [sickid]: {
          ...prevErrorState,
        },
      },
    };
  });
};
const handleDateChangeSickDay = (field, date, sickid) => {
setSickdayDietDetails((prev) =>
  prev.map((item) => {
    if (item.sickid === sickid) {
      const isStartDateBefore = IsDateBefore(date, dates?.oneYr_pretransplant_start);
      const isStartDateAfter = IsDateAfter(date, dates?.twenty_four_months_post_stabilization);

      // Initialize the updated object
      let updatedItem = {
        ...item,
        [field]: date || null,
        
      };
      setNutritionError((prevErrors) => {
        const prevErrorState = prevErrors["Q63."]?.[sickid] || {};
        let updatedErrorState = { ...prevErrorState };
      if (field === "start_dt") {

        updatedItem.startVisit = Values.value2;
        updatedItem.startDateInvalid = isStartDateBefore || isStartDateAfter; 
        updatedErrorState.startDateInvalid=false;
        updatedErrorState.startDateInvalidRange=false;
      } else if (field === "end_dt") {
        updatedItem.ongoingVisit = Values.value2;
        updatedErrorState.endDateInvalid = !date;
        updatedItem.endHospitalizationsUnkLTLKT = "";
      }
      return {
        ...prevErrors,
        ["Q63."]: {
          ...prevErrors["Q63."],
      
      [sickid]: updatedErrorState
        }
      };
    });
      return updatedItem;
    }
    return item;
  })
);
 };
useEffect(() => {
  setNutritionData((prev) => ({
    ...prev,
    "Q63.": sickdayDietDetails,
  }));
}, [sickdayDietDetails]);
useEffect(()=>{
  setHideMainColumns((prevColumns) => {
    const newColumns = [...prevColumns]; // Copy previous state
    /*BV - New logic based on derived Variables*/
    newColumns[0] = dates?.closest_oneYr_priorIndex
    newColumns[1] =dates?.closest_transplantAdmissionDt
    newColumns[2] = dates?.closest_transplantDischargeDt
    newColumns[3] = dates?.closest_threeMonths_afterIndex
    newColumns[4] =dates?.closest_fifteenMonths_afterIndex
    newColumns[5] =dates?.closest_twentysevenMonths_afterIndex_nutrition

  
    return newColumns;
  });

},[])

    return (
        <>
        {infoPopUpModal && (
    <InfoPopUp 
        OkClick={() => {setInfoPopUpModal(false);setDescription("")}}  // Replace with actual function
        description={description} // Replace with actual text
        key="infoPopup" // Key should be unique if rendering in a list, else remove it
    />
)}
        <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} 
            Save={SavePage} 
            />
          </div>
        </div>
      </section>
      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu 
          activePageId={SideMenuItems.NutritionManagement} 
          />
          
                  
                        <button
                            className={isSideMenuActive ? "openbtn" : "openbtn active"}
                            onClick={() =>
                                toggleSidebar(isSideMenuActive, setisSideMenuActive)
                            }
                        >
                            <i
                                id="arrowNavigation"
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                            ></i>
                        </button>
                  
                    <div className="col-pad-left eligibiltylocked" id="main">
                        <div className="survey-section-content" id="contentsec">
                            <div className="survey-section-content-header">
                                <h4>Nutrition Management </h4>
                            </div>
                            {showTopErrMsg && (
                                <div className="clean-error ">
                                    <ErrorField
                                        show={showTopErrMsg}
                                        message={CommonError_Msgs.Hard_Empty}
                                    />
                                </div>
                            )}
                            {/* <summary>
              date: 14-12-2024
              Name: ST
              description:  TransplantCharacteristics Design
              <summary> */}
              <div className="survey-question-section">
                <div className="survey-question-content survey-content-box">
                  <div className="question-answer grid-overflow">
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      border="0"
                      width="100%"
                      style={patientLocked ? { pointerEvents: 'none'} : {}}

                      
                    >
                      <tr>
                        <td className="">
                          {/* mainContent */}
                          <table
                            cellPadding="0"
                            cellSpacing="0"
                            width="100%"
                            border="1"
                            className="borderTable"
                          >

                            
                             <td className="containertd" colSpan={6}>

                              <div className="quest-text-pad question-weight">
                               
                                Please provide information from the diet record <u>on or closest to the target date</u> and within the specific record selection window. Note that <u>all records should have occurred outside of an MDE.</u>
                              </div>
                              
                              {/* Force line break */}
                              <br />
                            
                            </td>


                             <tr>
                              <td colSpan="6" style={{ padding: 0 }}>
                              <div style={{ maxHeight: "550px", overflowY: "auto", border: "1px solid #ccc" }}>

<table

  style={{ width: "100%", borderCollapse: "collapse" }}

  className="borderTable borderTable-auto-width"

>

  <thead

    style={{

      position: "sticky",

      top: 0,

      zIndex: 9,

      background: "#fff",

      //borderBottom: "2px solid #000",

    }}>

    <tr className="custom-position-rel" >

      <th

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-bottom"></div>

        Target date



      </th>

      <th

        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-left-first"></div>

        Closest to 1 year prior to the index date (<span className="indigo-text">{dates?.oneYr_pretransplant_start ? dates?.oneYr_pretransplant_start :

          "[1-year pre-transplant start]"}</span>)

      </th>

      <th



        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-left"></div>

        Closest to and before the transplant admission date (<span className="indigo-text" style={{ whiteSpace: "nowrap" }}>{dates?.transplant_admissionDt ? dates?.transplant_admissionDt :

          "[transplant admission date]"}</span>)



      </th>

      <th



        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-left"></div>

        Closest to the transplant discharge date (<span className="indigo-text">{dates?.transplant_dischargeDt ? dates?.transplant_dischargeDt :

          "[transplant discharge date]"}</span>) to represent diet status upon discharge

      </th>

      <th



        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-left"></div>

        Closest to 3 months after the index date (<span className="indigo-text">{dates?.three_month_stabilization ? dates?.three_month_stabilization :

          "[3-month stabilization date"}</span>)



      </th>

      <th



        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >



        <div className="floating-border-left"></div>

        Closest to 15 months after the index date (<span className="indigo-text">{dates?.twelve_month_post_stabilization ? dates?.twelve_month_post_stabilization :

          "[12-month post-stabilization date]"}</span>)



      </th>

      <th



        className="custom-position-rel"

        style={{ borderRight: "1px solid", borderColor: "inherit", padding: "8px", textAlign: "center", minWidth: "270px", maxWidth: "270px" }}

      >

        <div className="floating-border-left"></div>

        Closest to 27 months after the index date (<span className="indigo-text">{dates?.twenty_four_months_post_stabilization ? dates?.twenty_four_months_post_stabilization :

          "[24-month post-stabilization date]"}</span>)

      </th>

    </tr>

  </thead>

<tbody>
  {questions?.map((question, index) => (
     <React.Fragment key={question.nutritionQuestionId}>
    <tr key={question.nutritionQuestionId}>
      {/* First Column - Dynamic Question */}
      <td className="containertd" style={{ borderBottom: "0",minWidth: "270px",maxWidth:"270px", width:"270px",borderLeft:'none' }}>
        <div className="question question-weight">
          <span className="question-weight">{question.questionNumber}</span>
          <span className="quest-text-pad">

            <span dangerouslySetInnerHTML={{ __html: question.questionText }} />{" "}

            {index !==6 ?(<span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                setDescription("A diet prescription, commonly referred to as a “maintenance” or “at-home diet”, is defined as any prescribed diet plan inclusive of unrestricted diet, medical foods, or other recommended diet practices followed by a patient for the chronic management of MMA.");
                setInfoPopUpModal(true);
              }}
            >
              {question.questionHyperlink}
            </span>):(<span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                setDescription(`<p >A partial liberalization of dietary restrictions may include an increase in intact protein, the prescribed ratio of intact to medical food protein, or total prescribed protein intake per day. A total liberalization of dietary restrictions would be the removal of prescribed protein limits, allowing unrestricted intake of natural protein without reliance on medical foods.`);
                setInfoPopUpModal(true);
              }}
            >
              {question.questionHyperlink}
            </span>)}
            
          </span>
        </div>
        
      </td>

      {/* Render different input types based on question index */}
      {index === 0 ? (
        Array.from({ length: 6 })?.map((_, colIndex) => {
          const uniqueKey = fieldMapping[question.questionNumber]?.[colIndex]?.[colIndex] || `col-${question.questionNumber}-${colIndex}`; 
         return hideMainColumns[colIndex]===true ? (
           <td key={uniqueKey} className="containertd" style={{ borderBottom: "0" }}> 
            {[...Array(4)]?.map((_, divIndex) => {
                      const divKey = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndex] || `div-${colIndex}-${divIndex}`;

             return( <div key={divKey}>
                {divIndex === 0 ? (
                  <label>
                    <input
                      type="radio"
                     name={`radio_${"q58"}_${colIndex}`}
                      checked={
                        
                        (() => {
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[0];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 0)}
                    />
                    <span className="date-field-padding-left">
                      <DateControl 
                      date={
                        (() => {
                          
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[2]; // Adjust index based on your mapping
                          const selectedDate = nutritionData[question.questionNumber]?.[selectedField];
                    
                          return selectedDate ?? null; // Ensure the date is properly passed
                        })()
                      }
                      ctrlId={colIndex} HandleDateChange={handleDateChange}  optionId={question.questionNumber}/>
                    </span>
                  </label>
                ) : 
                
           divIndex===1?  (
                  <label className="estimated-date-padding text-margin">
                    <input
                      type="checkbox"
                      name={`checkbox_${index}`}
                      checked={
                        (() => {
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[1];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, 2)}
                    />
                    <span className="radio-text-padding">Estimated date</span>
                  </label>
                )
                :
                divIndex===2?(
                  (
                    <label>
                       <input
                      type="radio"
                      name={`radio_${"q58"}_${colIndex}`} // Unique name per column
                      checked={
                        
                        (() => {
                          
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[3];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 3)}
                    />
                      <span className="radio-text-padding">Date unknown</span>
                    </label>
                  )
                ):
                (
                  <label>
                     <input
                      type="radio"
                      name={`radio_${"q58"}_${colIndex}`} // Unique name per column
                      checked={
                        
                        (() => {
                          
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[4];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 4)}
                    />  
                    <span className="radio-text-padding">Not assessed</span>
                  </label>
                )
                
                }
              </div>)
        })}
            {/* {nutritionError[question.questionNumber]?.[colIndex] && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )} */}
        {nutritionError[question.questionNumber]?.[colIndex]?.missingValues && (
  <ErrorField
  show={true}
  message={CommonError_Msgs.Msg1}
/>
)}
{nutritionError[question.questionNumber]?.[colIndex]?.invalidRange && (
  <ErrorField
  show={true}
  message={CommonError_Msgs.Msg2}
/>
)}
          </td>
          ):(<td   className="question-weight cust-align containertd">Not Applicable</td> )
        })
      ) : index === 4 ? (
        Array.from({ length: 6 })?.map((_, colIndex) => {
          const uniqueKey = fieldMapping[question.questionNumber]?.[colIndex]?.[colIndex] || `col-${question.questionNumber}-${colIndex}`; 

         return (!hideColumns[colIndex] && hideMainColumns[colIndex]===true  )? (
          <td key={uniqueKey} className="containertd" style={{ borderBottom: "0" }}>
            {[...Array(4)]?.map((_, divIndex) => {
             const divKey = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndex] || `div-${colIndex}-${divIndex}`;

             return ( <div key={divKey}>
                {divIndex === 0 ? (
                  <label className="long-text-option">
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <span className="radio-text-padding">
                      <input
                        style={{ width: "75px", borderBottom: "1px solid" }}
                        type="text"
                        value={
                          (() => {
                            let divIndexx;
                            if (divIndex === 0) {
                              divIndexx = 1;
                            } else if (divIndex === 1) {
                              divIndexx = 3;
                            } else {
                              divIndexx = 5;
                            }
                      
                            const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                            return nutritionData[question.questionNumber]?.[selectedField] || "";
                          })()
                        }
                        onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)}
                        maxLength={8}/>
                    
                    <span>kcals/day</span>
                    </span>
                  </label>
                ) : divIndex === 1 ? (
                  <label className="long-text-option">
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <span className="radio-text-padding">
                      <input
                        style={{ width: "75px", borderBottom: "1px solid" }}
                        type="text"
                        value={
                          (() => {
                            let divIndexx;
                            if (divIndex === 0) {
                              divIndexx = 1;
                            } else if (divIndex === 1) {
                              divIndexx = 3;
                            } else {
                              divIndexx = 5;
                            }
                      
                            const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                            return nutritionData[question.questionNumber]?.[selectedField] || "";
                          })()
                        }
                        onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)} 
                        maxLength={8}/>
                      <span>kcals/kg<sub>weight</sub>/day</span>
                    </span>
                  </label>
                ) : divIndex === 2 ? (
                  <label className="option-fbox">
                     <input
                     className="custom-top-spacing"
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <div><span className="">Other, please specify:</span>
                    <input
                      className="input-dash"
                      type="text"
                      maxLength={300}
                      value={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 1;
                          } else if (divIndex === 1) {
                            divIndexx = 3;
                          } else {
                            divIndexx = 5;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)}/>
                      </div>
                    

                  </label>
                ) : (
                  <label className="long-text-option">
                    <input
                      type="radio"
                      onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx=fieldMapping[question.questionNumber]?.[colIndex].length-1;
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <span className="radio-text-padding">Unknown</span>
                  </label>
                )}
              </div>)
        })}
            {nutritionError[question.questionNumber]?.[colIndex]?.missingValues && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )}
        {nutritionError[question.questionNumber]?.[colIndex]?.invalidRange   && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg2}
         />
        )}
          </td>
          ):(<td  className="question-weight cust-align containertd">Not Applicable</td> )
        })
      ) : 

       index === 5 ? (
        <>
        {Array.from({ length: 6 })?.map((_, colIndex) => {
                    const uniqueKey = fieldMapping[question.questionNumber]?.[colIndex]?.[colIndex] || `col-${question.questionNumber}-${colIndex}`; 

          return  (!hideColumns[colIndex]&& hideMainColumns[colIndex]===true  )? (
          <td key={uniqueKey} className="containertd" style={{ borderBottom: "0" }}>
            <div>
              <label className="long-text-option">
                <input
                  type="checkbox"
                  onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, 0)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[0]] || false}
                />
                <span className="radio-text-padding">Oral</span>
              </label>
            </div>
      
            <div>
              <label className="long-text-option">
                <input
                  type="checkbox"
                  onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, 1)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[1]] || false}
                />
                <span className="radio-text-padding">Enteral/tube-based feeding</span>
              </label>
            </div>
      
            <div>
              <label className="long-text-option">
                <input
                  type="checkbox"
                  onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, 2)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[2]] || false}
                />
                <span className="radio-text-padding">Parenteral/IV-based feeding</span>
              </label>
            </div>
      
            <div>
              <label className="long-text-option">
                <input
                  type="radio"
                  name={`feedingType_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 3)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[3]] || false}
                />
                <span className="radio-text-padding">Unknown</span>
              </label>
            </div>
            {nutritionError[question.questionNumber]?.[colIndex] && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )}
          </td>
          
        ) :(<td  className="question-weight cust-align containertd">Not Applicable</td> )})}
       
        </>
      ) :
      index === 6 ? (
        Array.from({ length: 6 })?.map((_, colIndex) => {
          const uniqueKey = fieldMapping[question.questionNumber]?.[colIndex]?.[colIndex] || `col-${question.questionNumber}-${colIndex}`; 

       return  ( !hideColumns[colIndex] && hideMainColumns[colIndex]===true )? (
          <td key={uniqueKey} className="containertd" style={{ borderBottom: "0", minWidth: "270px",maxWidth:"270px", width:"270px" }}>
           <div>
              <label className="long-text-option">
                <input
                  type="radio"
                  name={`feedingType_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 0)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[0]] || false}
                />
                <span className="radio-text-padding">Yes</span>
              </label>
              {/* className="estimated-date-padding text-margin" */}
              <div className="estimated-date-padding text-margin">
              <label className="long-text-option">
              <input
                  type="radio"
                  name={`feedingType1_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 3)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[3]] || false}
                /> <span className="radio-text-padding">
                  Partial
            </span></label>
              </div>

              <div className="estimated-date-padding text-margin">
              <label className="long-text-option">
              <input
                  type="radio"
                  name={`feedingType1_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 4)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[4]] || false}
                /><span className="radio-text-padding">
                Total
          </span></label>
              </div>
            </div>
      
            <div>
              <label className="long-text-option">
                <input
                  type="radio"
                  name={`feedingType_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 1)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[1]] || false}
                />
                <span className="radio-text-padding">No</span>
              </label>
            </div>
      
            <div>
              <label className="long-text-option">
                <input
                  type="radio"
                  name={`feedingType_${question.questionNumber}_${colIndex}`} // Ensure unique name per column
                  onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, 2)}
                  checked={nutritionData[question.questionNumber]?.[fieldMapping[question.questionNumber]?.[colIndex]?.[2]] || false}
                />
                <span className="radio-text-padding">Unknown</span>
              </label>
            </div>
      
            
            {/* {nutritionError[question.questionNumber]?.[colIndex] && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )} */}
        {nutritionError[question.questionNumber]?.[colIndex]?.missingValues  && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )}
        {nutritionError[question.questionNumber]?.[colIndex]?.invalidRange   && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )}
          </td>
           ):(<td   className="question-weight cust-align " style={{minWidth: "270px",maxWidth:"270px", width:"270px" }}>Not Applicable</td> )
})
      ):
      (
        Array.from({ length: 6 })?.map((_, colIndex) => {
          const uniqueKey = fieldMapping[question.questionNumber]?.[colIndex]?.[colIndex] || `col-${question.questionNumber}-${colIndex}`; 

        return  (!hideColumns[colIndex]&& hideMainColumns[colIndex]===true  )? (
          <td key={uniqueKey} className="containertd" style={{ borderBottom: "0", minWidth: "270px",maxWidth:"270px", width:"270px" }}>
            {[...Array(4)]?.map((_, divIndex) => {
                                    const divKey = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndex] || `div-${colIndex}-${divIndex}`;

              return (<div key={divKey}>
                {divIndex === 0 ? (
                  <label className="long-text-option">
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <span className="radio-text-padding">
                      <input
                        style={{ width: "75px", borderBottom: "1px solid" }}
                        type="text"
                        value={
                          (() => {
                            let divIndexx;
                            if (divIndex === 0) {
                              divIndexx = 1;
                            } else if (divIndex === 1) {
                              divIndexx = 3;
                            } else {
                              divIndexx = 5;
                            }
                      
                            const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                            return nutritionData[question.questionNumber]?.[selectedField] || "";
                          })()
                        }
                        onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)}
                        maxLength={8}  />
                     <span>g<sub>protein</sub>/day</span>
                    </span>
                  </label>
                ) : divIndex === 1 ? (
                  <label className="long-text-option">
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <span className="radio-text-padding">
                      <input
                        style={{ width: "75px", borderBottom: "1px solid" }}
                        type="text"
                        value={
                          (() => {
                            let divIndexx;
                            if (divIndex === 0) {
                              divIndexx = 1;
                            } else if (divIndex === 1) {
                              divIndexx = 3;
                            } else {
                              divIndexx = 5;
                            }
                      
                            const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                            return nutritionData[question.questionNumber]?.[selectedField] || "";
                          })()
                        }
                        onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)}
                        maxLength={8}
                      />
                      <span>g<sub>protein</sub>/Kg<sub>weight</sub>/day</span>
                    </span>
                  </label>
                ) : divIndex === 2 ? (
                  <label  className="option-fbox">
                    <input
                      type="checkbox"
                      className="custom-top-spacing"
                      onChange={(e) => handleCheckboxChange(question.questionNumber, e, colIndex, divIndex)}
                      checked={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 0;
                          } else if (divIndex === 1) {
                            divIndexx = 2;
                          } else {
                            divIndexx = 4;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                    />
                    <div>
                    <span className="">Other, please specify:</span>
                    <input
                      className="input-dash"
                      type="text"
                      maxLength={300}
                      value={
                        (() => {
                          let divIndexx;
                          if (divIndex === 0) {
                            divIndexx = 1;
                          } else if (divIndex === 1) {
                            divIndexx = 3;
                          } else {
                            divIndexx = 5;
                          }
                    
                          const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                          return nutritionData[question.questionNumber]?.[selectedField] || "";
                        })()
                      }
                      onChange={(e) => handleTextChange(question.questionNumber, e, colIndex, divIndex)}
                    /></div>
                  </label>
                ) : (
                  <label className="long-text-option">
                    <input
                      type="radio"
                      onChange={(e) => handleRadioChange(question.questionNumber, e, colIndex, divIndex)}
                     checked={
                      (() => {
                        let divIndexx=fieldMapping[question.questionNumber]?.[colIndex].length-1;
                        const selectedField = fieldMapping[question.questionNumber]?.[colIndex]?.[divIndexx];
                        return nutritionData[question.questionNumber]?.[selectedField] || "";
                      })()
                    }
                    />
                    <span className="radio-text-padding">Unknown</span>
                  </label>
                )}
              </div>)
        })}
            {nutritionError[question.questionNumber]?.[colIndex]?.missingValues  && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg1}
         />
        )}
        {nutritionError[question.questionNumber]?.[colIndex]?.invalidRange   && (
           <ErrorField
           show={true}
           message={CommonError_Msgs.Msg2}
         />
        )}
          </td>
           ):(<td  className="question-weight cust-align containertd" style={{minWidth: "270px",maxWidth:"270px", width:"270px" }}>Not Applicable</td> )
})
      )}
    </tr>
    
    {index === 5 && (
      <tr>
        <td colSpan="7" className="sub-table-cell padding-zero">
          <DietAdministrationTable errorData={nutritionError} handleRadioChange={handleRadioChangeRoutes}  dietData={nutritionData["Q61."]} fieldData={nutritionData["Q61.1."]}/>
        </td>
      </tr>
    )}
  </React.Fragment>
))}
</tbody>


                                                                </table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="survey-question-section">
                                <div className="survey-question-content survey-content-box">
                                    <div className="question-answer grid-overflow">
                                        {/* Q35. */}
                                        <div className="question question-weight">
                                            <span>Q63.</span>
                                            <span className="quest-text-pad">
                                                Please list all usages of {" "}
                                               
                                                <span style={{ color: "blue", cursor: "pointer", textDecoration: 'underline' }}
                                                    onClick={() => {
                                                        setDescription(`<p style="font-weight: 500;">Sick-day diet practices are defined as any modification, including diet composition, route of administration, or otherwise, to a patient’s prescribed diet, implemented to mitigate the onset of an MDE, as a preventive measure, or in response to a full metabolic crisis.`);
                                                        setInfoPopUpModal(true);
                                                    }}>   “sick-day” diet practices </span>
                                                that occurred within 12 months prior to and 27 months after the index date (from {dates?.oneYr_pretransplant_start ? dates?.oneYr_pretransplant_start : <span className="indigo-text">1-year-pre-transplant start</span>} to {dates?.twenty_four_months_post_stabilization ? dates?.twenty_four_months_post_stabilization : <span className="indigo-text">24-month post-stabilization date</span>}).
                                                Add additional rows for each “sick-day” diet practice usage, as needed.</span>
                                        </div>
                                        {sickdayDietDetails &&
                                            sickdayDietDetails.length > 0 &&
                                            sickdayDietDetails.map((data, idx) => (
                                                <div key={`td-${data.sickid}`} className="loop-section-ul">
                                                    <div className="loop-head">
                                                        <span className="question-weight">
                                                            {GetOrdinal(idx + 1)} Sick-day diet
                                                        </span>
                                                        {idx !== 0 && (
                                                            <div className="delete-btn-div">
                                                                <img
                                                                    width="16px"
                                                                    src="../Assets/images/Icon-material-delete.png"
                                                                    alt=""
                                                                    onClick={() =>
                                                                        deleteHospitalizationVisitDetails(idx)
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="containertd grid-overflow" >
                                                        <table
                                                            cellPadding="0"
                                                            cellSpacing="0"
                                                            width="100%"
                                                            border="1"
                                                            className="borderTable custom-width-td"
                                                        >


                            <tr>
                              <td
                              >
                                <table
                                 style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}

                                >
                                  <thead>
                                    <tr>
                                      <th className="modal-popup-table-header-cell cust-pad">
                                        Start date of "sick-day" diet
                                      </th>
                                      <th className="modal-popup-table-header-cell cust-pad">
                                        End date of "sick-day" diet
                                      </th>
                                      <th className="modal-popup-table-header-cell cust-pad">
                                      Reason for diet usage 
                                      </th>
                                      <th className="modal-popup-table-header-cell cust-pad">
                                        Components of "sick-day" diet
                                      </th>
                                      
                                    </tr>
                                  </thead>
                                  
                                      <tbody
                                        key={data.sickid}>
                                        <tr>
                                          <td className="modal-popup-table-cell cust-td-pad">
                                            {idx === 0 &&
                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"startVisit-" + idx}
                                                    value={1}
                                                    checked={data.startVisit == Values.value1}
                                                    onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                  />
                                                  <span className="">
                                                    No "sick day" diet used during period
                                                  </span>
                                                </label>
                                              </div>
                                            }
                                            <div className="date-field-padding">
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"startVisit-" + idx}
                                                  value={2}
                                                  checked={data.startVisit == Values.value2}
                                                  onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                />

                                                <span className="">
                                                  
                                                                                                <DateControl
                                                                                                    optionId={data.sickid}
                                                                                                    ctrlId={"start_dt"}
                                                                                                    HandleDateChange={handleDateChangeSickDay}
                                                                                                    date={data.start_dt}
                                                                                                />
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="estimated-date-padding text-margin">
                                                                                        <label>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={idx}
                                                                                                name={"start_dt_estimated-" + idx}
                                                                                                checked={data.start_dt_estimated}
                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                            />
                                                                                            <span className="radio-text-padding">
                                                                                                Estimated Date
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="date-field-padding">
                                                                                        <label className="option-fbox">
                                                                                            <input
                                                                                                type="radio"
                                                                                                id={idx}
                                                                                                name={"startVisit-" + idx}
                                                                                                value={99}
                                                                                                checked={data.startVisit == Values.value99}
                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                            />
                                                                                            <span className="">
                                                                                                Date unknown
                                                                                            </span>
                                                                                        </label>
                                                                                        <div style={{ marginLeft: "44px" }}>
                                                                                            {dates?.zero_to12months_before_LT_LKT !== null && dates?.zero_to12months_before_LT_LKT &&
                                                                                                <div>
                                                                                                    <label className="option-fbox">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            id={idx}
                                                                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                                                                            value={1}
                                                                                                            checked={data.startHospitalizationsUnkLTLKT == Values.value1}
                                                                                                            onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                        />
                                                                                                        <span
                                                                                                            data-tooltip-id="encounterTip"
                                                                                                            className="modal-popup"
                                                                                                            onClick={() => {
                                                                                                                setDescription(`<div>
<p style="text-align: left;font-weight: 500;">
  Defined from ${dates?.oneYr_pretransplant_start} to ${dates?.oneYr_pretransplant_end}, inclusive.
</p>
</div>`);
                                                          setInfoPopUpModal(true);
                                                        }}
                                                      >
                                                        0 to 12 months before LT/LKT
                                                      </span>


                                                                                                    </label>
                                                                                                </div>}
                                                                                            {dates?.zero_to_3months_after_LT_LKT !== null && dates?.zero_to_3months_after_LT_LKT &&
                                                                                                <div>
                                                                                                    <label className="option-fbox">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            id={idx}
                                                                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                                                                            value={2}
                                                                                                            checked={data.startHospitalizationsUnkLTLKT == Values.value2}
                                                                                                            onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                        />
                                                                                                        <span
                                                                                                            data-tooltip-id="encounterTip"
                                                                                                            className="modal-popup"

                                                                                                            onClick={() => {
                                                                                                                setDescription(`<div>
  <p style="text-align: left;font-weight: 500;">
    Defined from ${dates?.indexDt} to ${dates?.three_month_stabilization}, inclusive.
  </p>
</div>`);
                                                          setInfoPopUpModal(true);
                                                        }}
                                                      >
                                                        0 to 3 months after LT/LKT
                                                      </span>

                                                                                                    </label>
                                                                                                </div>}
                                                                                            {dates?.four_to_15months_after_LT_LKT !== null && dates?.four_to_15months_after_LT_LKT &&
                                                                                                <div>
                                                                                                    <label className="option-fbox">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            id={idx}
                                                                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                                                                            value={3}
                                                                                                            checked={data.startHospitalizationsUnkLTLKT == Values.value3}
                                                                                                            onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                        />
                                                                                                        <span
                                                                                                            data-tooltip-id="encounterTip"
                                                                                                            className="modal-popup"
                                                                                                            onClick={() => {
                                                                                                                setDescription(`<div>
<p style="text-align: left;font-weight: 500;">
 Defined from ${dates?.post_stabilization_start} to ${dates?.twelve_month_post_stabilization}, inclusive.
</p>
</div>`);
                                                          setInfoPopUpModal(true);
                                                        }}
                                                      >
                                                        4 to 15 months after LT/LKT
                                                      </span>


                                                                                                    </label>
                                                                                                </div>}
                                                                                            {dates?.sixteen_to_27months_after_LT_LKT !== null && dates?.sixteen_to_27months_after_LT_LKT &&
                                                                                                <div>
                                                                                                    <label className="option-fbox">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            id={idx}
                                                                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                                                                            value={4}
                                                                                                            checked={data.startHospitalizationsUnkLTLKT == Values.value4}
                                                                                                            onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                        />
                                                                                                        <span
                                                                                                            data-tooltip-id="encounterTip"
                                                                                                            className="modal-popup"
                                                                                                            onClick={() => {
                                                                                                                setDescription(`<div>
  <p style="text-align: left;font-weight: 500;">
    Defined from ${dates?.twelve_month_post_stabilization_plusOneday} to ${dates?.twenty_four_months_post_stabilization}, inclusive.
  </p>
</div>`);
                                                          setInfoPopUpModal(true);
                                                        }}
                                                      >
                                                        16 to 27 months after LT/LKT
                                                      </span>

                                                    </label>
                                                  </div>}
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={"startHospitalizationsUnkLTLKT-" + idx}
                                                      value={5}
                                                      checked={data.startHospitalizationsUnkLTLKT == Values.value5}
                                                      onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                    />
                                                    <span className="">
                                                      Date completely unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            {nutritionError["Q63."]?.[[data.sickid]]?.startDateInvalid  && (
                                              <ErrorField
                                                 show={true}
                                                 message={CommonError_Msgs.Msg1}
                                                />
                                              )}
                                              
                                              {nutritionError["Q63."]?.[[data.sickid]]?.startDateInvalidRange  && (
                                              <ErrorField
                                                 show={true}
                                                 message={CommonError_Msgs.Msg2}
                                                />
                                              )}
                                            
                                             
                                          </td>

                                          {data.startVisit == Values.value1 ? (
                                            <td
                                              className="containertd"
                                              style={{
                                                textAlign: "center",
                                                borderRight: "0",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="modal-popup-table-cell cust-td-pad">
                                              <div className="date-field-padding" >
                                                <label className="option-fbox" style={{marginTop:'14px'}}>
                                                  
                                                  <span className="">
                                                    {/* Visit is ongoing */}{" "}
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"ongoingVisit-" + idx}
                                                    value={2}
                                                    checked={data.ongoingVisit == Values.value2}
                                                    onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                  />

                                                                                                <span className="">
                                                                                                    <DateControl
                                                                                                        optionId={data.sickid}
                                                                                                        ctrlId={"end_dt"}
                                                                                                        HandleDateChange={handleDateChangeSickDay}
                                                                                                        date={data.end_dt}
                                                                                                    />
                                                                                                </span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="estimated-date-padding text-margin">
                                                                                            <label>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={idx}
                                                                                                    name={"end_dt_estimated-" + idx}
                                                                                                    checked={data.end_dt_estimated}
                                                                                                    onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                />
                                                                                                <span className="radio-text-padding">
                                                                                                    Estimated Date
                                                                                                </span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="date-field-padding">
                                                                                            <label className="option-fbox">
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    id={idx}
                                                                                                    name={"ongoingVisit-" + idx}
                                                                                                    value={99}
                                                                                                    checked={data.ongoingVisit == Values.value99}
                                                                                                    onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                />
                                                                                                <span className="">
                                                                                                    Date unknown
                                                                                                </span>
                                                                                            </label>
                                                                                            <div style={{ marginLeft: "44px" }}>
                                                                                                {dates?.zero_to12months_before_LT_LKT !== null && dates?.zero_to12months_before_LT_LKT &&
                                                                                                    <div>
                                                                                                        <label className="option-fbox">
                                                                                                            <input
                                                                                                                type="radio"
                                                                                                                id={idx}
                                                                                                                name={"endHospitalizationsUnkLTLKT-" + idx}
                                                                                                                value={1}
                                                                                                                checked={data.endHospitalizationsUnkLTLKT == Values.value1}
                                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                            />
                                                                                                            <span
                                                                                                                data-tooltip-id="encounterTip"
                                                                                                                className="modal-popup"

                                                                                                                onClick={() => {
                                                                                                                    setDescription(`<div>
  <p style="text-align: left;font-weight: 500;">
    Defined from ${dates?.oneYr_pretransplant_start} to ${dates?.oneYr_pretransplant_end}, inclusive.
  </p>
</div>`);
                                                            setInfoPopUpModal(true);
                                                          }}
                                                        >
                                                          0 to 12 months before LT/LKT
                                                        </span>

                                                                                                        </label>
                                                                                                    </div>}
                                                                                                {dates?.zero_to_3months_after_LT_LKT !== null && dates?.zero_to_3months_after_LT_LKT &&
                                                                                                    <div>
                                                                                                        <label className="option-fbox">
                                                                                                            <input
                                                                                                                type="radio"
                                                                                                                id={idx}
                                                                                                                name={"endHospitalizationsUnkLTLKT-" + idx}
                                                                                                                value={2}
                                                                                                                checked={data.endHospitalizationsUnkLTLKT == Values.value2}
                                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                            />
                                                                                                            <span
                                                                                                                data-tooltip-id="encounterTip"
                                                                                                                className="modal-popup"
                                                                                                                onClick={() => {
                                                                                                                    setDescription(`<div>
    <p style="text-align: left;font-weight: 500;">
      Defined from ${dates?.indexDt} to ${dates?.three_month_stabilization}, inclusive.
    </p>
  </div>`);
                                                            setInfoPopUpModal(true);
                                                          }}
                                                        >
                                                          0 to 3 months after LT/LKT
                                                        </span>

                                                                                                        </label>
                                                                                                    </div>}
                                                                                                {dates?.four_to_15months_after_LT_LKT !== null && dates?.four_to_15months_after_LT_LKT &&
                                                                                                    <div>
                                                                                                        <label className="option-fbox">
                                                                                                            <input
                                                                                                                type="radio"
                                                                                                                id={idx}
                                                                                                                name={"endHospitalizationsUnkLTLKT-" + idx}
                                                                                                                value={3}
                                                                                                                checked={data.endHospitalizationsUnkLTLKT == Values.value3}
                                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                            />
                                                                                                            <span
                                                                                                                data-tooltip-id="encounterTip"
                                                                                                                className="modal-popup"

                                                                                                                onClick={() => {
                                                                                                                    setDescription(`<div>
  <p style="text-align: left;font-weight: 500;">
   Defined from ${dates?.post_stabilization_start} to ${dates?.twelve_month_post_stabilization}, inclusive.
  </p>
</div>`);
                                                            setInfoPopUpModal(true);
                                                          }}
                                                        >
                                                          4 to 15 months after LT/LKT
                                                        </span>

                                                                                                        </label>
                                                                                                    </div>}
                                                                                                {dates?.sixteen_to_27months_after_LT_LKT !== null && dates?.sixteen_to_27months_after_LT_LKT &&
                                                                                                    <div>
                                                                                                        <label className="option-fbox">
                                                                                                            <input
                                                                                                                type="radio"
                                                                                                                id={idx}
                                                                                                                name={"endHospitalizationsUnkLTLKT-" + idx}
                                                                                                                value={4}
                                                                                                                checked={data.endHospitalizationsUnkLTLKT == Values.value4}
                                                                                                                onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                                                                            />
                                                                                                            <span
                                                                                                                data-tooltip-id="encounterTip"
                                                                                                                className="modal-popup"
                                                                                                                onClick={() => {
                                                                                                                    setDescription(`<div>
    <p style="text-align: left;font-weight: 500;">
      Defined from ${dates?.twelve_month_post_stabilization_plusOneday} to ${dates?.twenty_four_months_post_stabilization}, inclusive.
    </p>
  </div>`);
                                                            setInfoPopUpModal(true);
                                                          }}
                                                        >
                                                          16 to 27 months after LT/LKT
                                                        </span>

                                                      </label>
                                                    </div>}
                                                  <div>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"endHospitalizationsUnkLTLKT-" + idx}
                                                        value={5}
                                                        checked={data.endHospitalizationsUnkLTLKT == Values.value5}
                                                        onChange={(e)=>HandleFieldChange(e,data.sickid)}
                                                      />
                                                      <span className="">
                                                        Date completely unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                              {nutritionError["Q63."]?.[[data.sickid]]?.endDateInvalid  && (
                                              <ErrorField
                                                 show={true}
                                                 message={CommonError_Msgs.Msg1}
                                                />
                                              )}
                                             
                                            </td>)}


                                          {data.startVisit == Values.value1 ? (
                                            <td
                                              className="containertd"
                                              style={{
                                                textAlign: "center",
                                                borderRight: "0",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="modal-popup-table-cell cust-td-pad">
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                  className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.rfdMitigation}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"rfdMitigation",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Mitigating exacerbation of MMA-related signs/symptoms 
                                                  </span>
                                                </label>
                                              </div>



                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                                                                    className="custom-top-spacing"

                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.rfdDuring}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"rfdDuring",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Diet management during MDE (i.e., to reduce MDE severity)
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.rfdAfter}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"rfdAfter",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Diet management after MDE (i.e., to support patient recover post-MDE)
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.rfdRenal}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"rfdRenal",data.sickid)}}
                                                  />

                                                                                                <span className="">
                                                                                                    Managing renal complication or renal insufficiency due to MMA disease
                                                                                                </span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="date-field-padding">
                                                                                            <label className="option-fbox">
                                                                                                <input
                                                                                                    className="custom-top-spacing"
                                                                                                    type="checkbox"
                                                                                                    id={idx}
                                                                                                    name={"rvOther-" + idx}
                                                                                                    checked={data.rfdOtherMedical}
                                                                                                    onChange={(e) => { handleCheckboxChangeSickDay(e, "rfdOtherMedical", data.sickid) }}
                                                                                                />
                                                                                                <div>
                                                                                                <span className="">
                                                                                                    Other medical diagnosis, please specify:
                                                                                                </span>
                                                                                          
                                                                                            <input
                                                                                                className="input-dash"
                                                                                                type="text"
                                                                                                id={idx}
                                                                                                name={"rfdOtherMedical_txt-" + idx}
                                                                                                value={data.rfdOtherMedical_txt}
                                                                                                maxLength={300}
                                                                                                onChange={(e) => handleTextChangeSickDay(e, "rfdOtherMedical_txt", data.sickid)}
                                                                                            /></div>
                                                                                            </label>  
                                                                                        </div>

                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rfdOtherReason-" + idx}
                                                    checked={data.rfdOtherReason}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"rfdOtherReason",data.sickid)}}
                                                  />

                                                                                                <div><span className="">
                                                                                                    Other reason, please specify:
                                                                                                </span>
                                                                                           
                                                                                            <input
                                                                                                className="input-dash"
                                                                                                type="text"
                                                                                                id={idx}
                                                                                                name={"rfdOtherReason_txt-" + idx}
                                                                                                value={data.rfdOtherReason_txt}
                                                                                                maxLength={300}
                                                                                                onChange={(e) => handleTextChangeSickDay(e, "rfdOtherReason_txt", data.sickid)}
                                                                                            /></div>
                                                                                             </label>
                                                                                        </div>

                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"soc-" + idx}
                                                    value={data.rfdUnknown==Values.value99}
                                                    checked={data.rfdUnknown == Values.value99}
                                                    onChange={(e)=>handleRadioChangeSickDay(e,"rfdUnknown",data.sickid)}
                                                  />
                                                  <span
                                                    className=""
                                                    style={{ textWrap: "nowrap" }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                              {nutritionError["Q63."]?.[[data.sickid]]?.rfdInvalid && (
                                              <ErrorField
                                                 show={true}
                                                 message={CommonError_Msgs.Msg1}
                                                />
                                              )}
                                             

                                              
                                            </td>)}


                                          {data.startVisit == Values.value1 ? (
                                            <td
                                              className="containertd"
                                              style={{
                                                textAlign: "center",
                                                borderRight: "0",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="modal-popup-table-cell cust-td-pad">

                                              
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietary}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietary",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Dietary restriction
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietaryCalory}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietaryCalory",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Calorie restriction
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietaryProtien}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietaryProtien",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Protein restriction
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding" style={{marginLeft:'56px'}}>
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietaryProtienZero}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietaryProtienZero",data.sickid)}}
                                                  />

                                                  <span  className="">
                                                  Zero-protein diet
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietaryCarb}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietaryCarb",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Carbohydrate restriction
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosDietaryLipid}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosDietaryLipid",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Fat/lipid restriction
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"rvUnknown2-" + idx}
                                                    checked={data.cosDietaryUnknown == Values.value99}
                                                    value={data.cosDietaryUnknown==Values.value99}
                                                    onChange={(e)=>handleRadioChangeSickDay(e,"cosDietaryUnknown",data.sickid)}
                                                  />
                                                  <span
                                                    className=""
                                                    style={{ textWrap: "nowrap" }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>

                                              </div>
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.modidfied}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"modidfied",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Modified route of diet administration
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom" >
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.modifiedNo}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"modifiedNo",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  No oral feeding
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.modifiedParental}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"modifiedParental",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Parenteral/IV feeding required
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.modifiedEnteral}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"modifiedEnteral",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Enteral/tube feeding required
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding left-margin-custom">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"rvUnknown1-" + idx}
                                                    checked={data.modifiedUnknown == Values.value99}
                                                    value={data.modifiedUnknown==Values.value99}
                                                    onChange={(e)=>handleRadioChangeSickDay(e,"modifiedUnknown",data.sickid)}
                                                  />
                                                  <span
                                                    className=""
                                                    style={{ textWrap: "nowrap" }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>

                                              </div>
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosIncreased}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosIncreased",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Increased intake of medical foods (e.g., high-calorie or nutrient-dense foods, etc.)
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvMMA-" + idx}
                                                    checked={data.cosMiscro}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosMiscro",data.sickid)}}
                                                  />

                                                  <span className="">
                                                  Micronutrient supplementation
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="date-field-padding">
                                              <label className="option-fbox">
                                                  <input
                                                   className="custom-top-spacing"
                                                    type="checkbox"
                                                    id={idx}
                                                    name={"rvOther-" + idx}
                                                    checked={data.cosOther}
                                                    onChange={(e)=>{handleCheckboxChangeSickDay(e,"cosOther",data.sickid)}}
                                                  />
<div>
                                                  <span className="">
                                                    Other, please specify:
                                                  </span>
                                               
                                                <input
                                                  className="input-dash"
                                                  type="text"
                                                  id={idx}
                                                  name={"cosOther_Txt" + idx}
                                                  value={data.cosOther_Txt}
                                                  maxLength={300}
                                                  onChange={(e)=>{handleTextChangeSickDay(e,"cosOther_Txt",data.sickid)}}
                                                  /> </div></label>
                                              </div>

                                              <div className="date-field-padding">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"rvUnknown-" + idx}
                                                    checked={data.cosUnknown == Values.value99}
                                                    value={data.cosUnknown==Values.value99}
                                                    //checked={data.rfdUnknown === Values.value99}
                                                    onChange={(e)=>handleRadioChangeSickDay(e,"cosUnknown",data.sickid)}
                                                  />
                                                  <span
                                                    className=""
                                                    style={{ textWrap: "nowrap" }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>

                                              </div>
                                              {nutritionError["Q63."]?.[data.sickid]?.cosDietaryInvalid && (
                                              <ErrorField
                                                 show={true}
                                                 message={CommonError_Msgs.Msg1}
                                                />
                                              )}
                                              
                                            </td>
                                          )}

                                          
                                        </tr>
                                      </tbody>
                                   



                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div></div>))}
                                        {
                                            sickdayDietDetails && sickdayDietDetails[0].startVisit != 1 && patientLocked===false &&
                                            <div>
                                                <div className="answer-list-text" onClick={addSickdayDietRow}>
                                                    <a>
                                                        <img width="18px" src="../Assets/images/plus.png" alt="" />
                                                    </a>
                                                    <a className="radio-text-padding">
                                                    Click here to add another “sick-day” diet
                                                    </a>
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="survey-section-content-foot">
                                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default NutritionManagement;